/* Pistacho — ficha de produto alternativa (?view=2).

   Tudo o que esta pagina mostra sai dos dados do produto. O desenho de cotas e
   desenhado aqui, a escala, a partir da string de medidas — nao e uma imagem
   nem um render. Duas armadilhas que o catalogo real tem:

     - metade das pecas esta escrita em cm e a outra metade em mm;
     - "42.3" nao e quarenta e dois mil e trezentos.

   Sem tratar as duas, um candeeiro de 42 cm sai do tamanho de uma moeda ao lado
   de uma porta de dois metros. */

(function () {
  'use strict';

  var raiz = document.querySelector('[data-pdp2]');
  if (!raiz) return;
  var bruto = raiz.querySelector('[data-pdp2-dados]');
  if (!bruto) return;

  // As frases vem dos locales, num bloco JSON que a seccao escreve na lingua
  // da pagina (data-pdp2-t). Aqui so se trocam os {marcadores}.
  var T = {};
  try { T = JSON.parse(raiz.querySelector('[data-pdp2-t]').textContent) || {}; } catch (e) { T = {}; }

  // Fotos do «Ver de perto» no PC (snippets/pdp2-visor-fotos.liquid), pela
  // chave do ficheiro da amostra. Sem foto, o visor mostra a textura.
  var fotosVisor = {};
  try { fotosVisor = JSON.parse(document.querySelector('[data-pdp2-visor-fotos]').textContent) || {}; } catch (e) { fotosVisor = {}; }
  function fotoVisor(tex) {
    if (!tex || !window.matchMedia || !window.matchMedia('(min-width: 900px)').matches) return '';
    var chave = String(tex).split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
    return fotosVisor[chave] || '';
  }
  function tr(k, v) {
    var s = T[k] || '';
    if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
    return s;
  }
  function emSel(titulo, vals) { return tr('em', { t: titulo, v: vals.join(tr('e')) }); }

  var D;
  try { D = JSON.parse(bruto.textContent); } catch (e) { return; }

  /* ---- as opcoes traduzidas ---------------------------------------------

     As amostras (option_swatches), as fotografias por combinacao
     (combo_images), o petproof e os desenhos estao escritos com os nomes e
     valores das opcoes EM PT. Em /en e /es o Shopify entrega as opcoes
     traduzidas («Tecido» chega «Fabric», «Madeira Carvalho» chega «Oak») e
     a comparacao pelo texto falhava: sem amostras, sem fotografias da escolha.

     O Liquid nao consegue ler o PT numa pagina noutra lingua, mas o id da
     variante e o mesmo em todas. A seccao da o endereco da peca em PT
     (D.fonte_pt, so fora da lingua principal); daqui tira-se, variante a
     variante e posicao a posicao, o par PT -> traduzido, e os dados escritos
     em PT passam para a lingua da pagina antes de a ficha arrancar. O resto
     do codigo continua a trabalhar com os valores que se veem.

     Em PT nada disto corre (nao ha D.fonte_pt) e a pagina e a de sempre. */
  var PT = null;
  function tem(o, k) { return !!o && Object.prototype.hasOwnProperty.call(o, k); }
  function comoPT(i, v) { return PT ? PT.val(i, v) : v; }

  function localizar(pt) {
    var ops = D.opcoes || [];
    if (!pt || !pt.options || pt.options.length !== ops.length) return;
    var nomesPT = [], aLocal = [], aPT = [], mudou = false;
    ops.forEach(function (o, i) {
      var n = pt.options[i];
      nomesPT[i] = String((n && typeof n === 'object' ? n.name : n) || o.nome);
      aLocal[i] = {}; aPT[i] = {};
      if (nomesPT[i] !== o.nome) mudou = true;
    });
    var porId = {};
    (pt.variants || []).forEach(function (v) { porId[String(v.id)] = v; });
    (D.variantes || []).forEach(function (v) {
      var q = porId[String(v.id)];
      if (!q || !q.options) return;
      ops.forEach(function (o, i) {
        var vp = q.options[i], vl = v.o[i];
        if (vp == null || vl == null) return;
        vp = String(vp);
        aLocal[i][vp] = vl;
        aPT[i][vl] = vp;
        if (vp !== vl) mudou = true;
      });
    });
    if (!mudou) return;

    function eixoPT(k) {
      var s = String(k).toLowerCase();
      for (var i = 0; i < nomesPT.length; i++) if (nomesPT[i].toLowerCase() === s) return i;
      return -1;
    }
    function eixoPorValor(v) {
      for (var i = 0; i < aLocal.length; i++) if (tem(aLocal[i], v)) return i;
      return -1;
    }
    function valLocal(i, v) { return tem(aLocal[i], v) ? aLocal[i][v] : v; }
    // um valor sem eixo (petproof, desenhos): o original e o de cada eixo que o tenha
    function todasAsFormas(v) {
      var r = [v];
      aLocal.forEach(function (m) { if (tem(m, v) && r.indexOf(m[v]) < 0) r.push(m[v]); });
      return r;
    }

    // Tudo se calcula a parte e so se troca no fim: a meio, nada fica misturado.
    var sw = {};
    Object.keys(D.swatches || {}).forEach(function (k) {
      var i = eixoPT(k), orig = D.swatches[k] || {};
      if (i < 0) { sw[k] = orig; return; }
      var nk = ops[i].nome, dest = sw[nk] || {};
      Object.keys(orig).forEach(function (v) { dest[valLocal(i, v)] = orig[v]; });
      sw[nk] = dest;
    });

    var pp = [];
    (D.petproof || []).forEach(function (v) {
      todasAsFormas(v).forEach(function (x) { if (pp.indexOf(x) < 0) pp.push(x); });
    });

    var combos = D.combos;
    if (combos && combos.items && combos.items.length) {
      combos = JSON.parse(JSON.stringify(combos));
      combos.items.forEach(function (it) {
        var novo = {};
        Object.keys(it.sel || {}).forEach(function (k) {
          var v = it.sel[k];
          // o eixo das fotos pelo nome em PT; senao, pelo eixo que tem o valor
          // (no SLIM e no HUG as fotos dizem «tecido» e a opcao «Revestimento»)
          var i = eixoPT(k);
          if (i < 0) i = eixoPorValor(v);
          if (i < 0) { novo[k] = v; return; }
          novo[ops[i].nome] = valLocal(i, v);
        });
        it.sel = novo;
      });
    }

    var des = {};
    Object.keys(D.desenhos || {}).forEach(function (v) {
      todasAsFormas(v).forEach(function (x) { des[x] = D.desenhos[v]; });
    });

    D.swatches = sw;
    D.petproof = pp;
    D.combos = combos;
    D.desenhos = des;
    PT = { nomes: nomesPT, val: function (i, v) { return tem(aPT[i], v) ? aPT[i][v] : v; } };
  }

  function arrancar() {

  var nomes = (D.opcoes || []).map(function (o) { return o.nome; });

  // As fotografias por combinacao (combo_images) nem sempre usam o nome da
  // opcao da loja: no SLIM e no HUG o eixo das fotos chama-se "tecido" e a
  // opcao chama-se "Revestimento". Sem acerto, esse eixo era ignorado, todas
  // as fotografias serviam para todos os revestimentos, e trocar de amostra
  // nao mudava imagem nenhuma. Cada eixo das fotos passa a chamar-se como a
  // opcao que tem os seus valores.
  (function acertarEixosDasFotos() {
    var itens = (D.combos && D.combos.items) || [];
    if (!itens.length || !nomes.length) return;
    var existe = function (n) { return nomes.some(function (x) { return x.toLowerCase() === n.toLowerCase(); }); };
    var mapa = {};
    itens.forEach(function (it) {
      Object.keys(it.sel || {}).forEach(function (k) {
        if (existe(k) || mapa[k] !== undefined) return;
        var o = (D.opcoes || []).filter(function (op) { return op.valores.indexOf(it.sel[k]) >= 0; })[0];
        mapa[k] = o ? o.nome : null;
      });
    });
    if (!Object.keys(mapa).some(function (k) { return mapa[k]; })) return;
    itens.forEach(function (it) {
      var novo = {};
      Object.keys(it.sel || {}).forEach(function (k) { novo[mapa[k] || k] = it.sel[k]; });
      it.sel = novo;
    });
  })();
  // Sem eixos nao ha nada para escolher: o Shopify inventa uma opcao "Title"
  // com o valor "Default Title" e a ficha mostrava-a como se fosse uma escolha.
  var temEixos = nomes.length > 0;
  var petproof = D.petproof || [];
  var swatches = D.swatches || {};

  // Selecao inicial: a primeira variante que se vende. No TONE WOOD e nas
  // mesas a primeira da lista e a de pedra, que so se ve (indisponivel), e a
  // pagina abria com o botao apagado.
  var v0 = D.variantes.filter(function (x) { return x.ok !== false; })[0] || D.variantes[0];
  var sel = (v0 && v0.o.slice()) || [];

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  // As texturas do PIM sao macros de 1 600 px. Numa bolinha de 44 px isso sao
  // 100 KB por amostra, e uma ficha de sofa trazia nove: 800 KB de imagens que
  // ninguem chega a ver ao tamanho a que foram servidas. O CDN do Shopify
  // redimensiona a pedido; so faltava pedir. A excepcao e o fundo do visor, que
  // e precisamente a textura em tamanho real — esse fica como esta.
  function emLargura(u, w) {
    if (!u) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // O visor cobre o ecra inteiro (background-size: cover) com a textura. As
  // mestras tem 4 096 px para monitores grandes; um telemovel so precisa do lado
  // maior do ecra vezes a densidade. Degraus fixos para o CDN reaproveitar cache.
  function larguraVisor() {
    var px = Math.max(window.innerWidth || 0, window.innerHeight || 0) * (window.devicePixelRatio || 1);
    var degraus = [1200, 1800, 2400, 3200, 4096];
    for (var i = 0; i < degraus.length; i++) if (px <= degraus[i]) return degraus[i];
    return 4096;
  }

  /* ---- medidas -------------------------------------------------------- */

  // O desenho de cotas mudou-se para assets/pistacho-cotas.js: a ficha que esta
  // no ar passou a desenhar as mesmas pecas e nao as pode desenhar de outra
  // maneira. Aqui ficam so os nomes curtos.
  var MOTOR = window.PistachoCotas;
  if (!MOTOR) return;
  var ROTULOS = MOTOR.ROTULOS, lerMedidas = MOTOR.ler, mm = MOTOR.mm, desenharTecnico = MOTOR.desenhar;

  /* ---- variantes ------------------------------------------------------- */

  function variante(combo) {
    for (var i = 0; i < D.variantes.length; i++) {
      var v = D.variantes[i], ok = true;
      for (var j = 0; j < combo.length; j++) if (v.o[j] !== combo[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  /* ---- imagens --------------------------------------------------------- */

  function eixoDe(nome) {
    return nomes.findIndex(function (n) { return n.toLowerCase() === nome.toLowerCase(); });
  }

  // Devolve as fotografias E o que elas mostram de facto. Oito das vinte
  // combinacoes do ISLET nao foram fotografadas — as tres Aqua entre elas, que
  // sao justamente as que a pagina destaca. Mostrar outra peca com a legenda da
  // escolhida seria dizer que aquilo e o tecido escolhido, e nao e.
  // `manter`: o eixo que a pessoa acabou de tocar (ou tem o rato por cima).
  // Esse nunca cede — sao os outros que cedem, para a fotografia mostrar a
  // opcao que se esta a ver. Se nenhuma fotografia tiver essa opcao, mostra-se
  // a fotografia por omissao da peca, e diz-se.
  function imagens(manter) {
    var itens = (D.combos && D.combos.items) || [];

    function busca(ignorar) {
      var r = itens.filter(function (it) {
        return Object.keys(it.sel || {}).every(function (eixo) {
          if (eixo.toLowerCase() === ignorar) return true;
          var i = eixoDe(eixo);
          return i < 0 || sel[i] === it.sel[eixo];
        });
      });
      return r.length ? r : null;
    }

    var achados = busca(null);
    if (achados) return { urls: achados.map(function (i) { return i.url; }), sel: sel.slice(), exacto: true };

    // Cede um eixo de cada vez e fica numa SO combinacao: tres fotografias de
    // tres tecidos diferentes lado a lado seriam tres pecas a fingir de uma.
    for (var k = nomes.length - 1; k >= 0; k--) {
      if (k === manter) continue;
      achados = busca(nomes[k].toLowerCase());
      if (!achados) continue;
      var chave = Object.keys(achados[0].sel).filter(function (e) {
        return e.toLowerCase() === nomes[k].toLowerCase();
      })[0];
      if (!chave) continue;
      var escolhido = achados[0].sel[chave];
      achados = achados.filter(function (it) { return it.sel[chave] === escolhido; });
      var real = sel.slice();
      var i = eixoDe(nomes[k]);
      if (i >= 0) real[i] = escolhido;
      return { urls: achados.map(function (x) { return x.url; }), sel: real, exacto: false, cedeu: nomes[k] };
    }

    // Com varios eixos a ceder ao mesmo tempo: qualquer fotografia com a opcao
    // mantida, a que mais se parecer com o resto da escolha.
    if (manter >= 0 && itens.length) {
      var nomeM = nomes[manter];
      var comOpcao = itens.filter(function (it) {
        var ch = Object.keys(it.sel || {}).filter(function (e) { return e.toLowerCase() === nomeM.toLowerCase(); })[0];
        return ch && it.sel[ch] === sel[manter];
      });
      if (comOpcao.length) {
        var pontos = function (it) {
          return Object.keys(it.sel || {}).filter(function (e) { var j = eixoDe(e); return j >= 0 && sel[j] === it.sel[e]; }).length;
        };
        comOpcao.sort(function (a, b) { return pontos(b) - pontos(a); });
        var alvoSel = comOpcao[0].sel;
        var grupo = comOpcao.filter(function (it) { return JSON.stringify(it.sel) === JSON.stringify(alvoSel); });
        var real2 = sel.slice();
        Object.keys(alvoSel).forEach(function (e) { var j = eixoDe(e); if (j >= 0) real2[j] = alvoSel[e]; });
        var cedido = nomes.filter(function (n, j) { return real2[j] !== sel[j]; })[0];
        return { urls: grupo.map(function (x) { return x.url; }), sel: real2, exacto: false, cedeu: cedido };
      }
      if (itens.length) {
        // nenhuma fotografia desta opcao: a primeira da peca, e diz-se
        var primeira = itens[0].sel;
        var grupo0 = itens.filter(function (it) { return JSON.stringify(it.sel) === JSON.stringify(primeira); });
        return { urls: grupo0.map(function (x) { return x.url; }), sel: null, exacto: false, semFoto: nomes[manter] ? sel[manter] : '' };
      }
    }

    // Sem `combo_images`, a pagina mostrava as seis primeiras imagens da
    // galeria como se fossem seis vistas — nos candeeiros sao as seis CORES.
    // A fotografia da propria variante e a unica verdade disponivel aqui.
    var v = variante(sel);
    if (v && v.img) return { urls: [v.img], sel: sel.slice(), exacto: true };
    return { urls: (D.media || []).slice(0, 6).map(function (m) { return m.url; }), sel: null, exacto: false };
  }

  /* ---- enquadramento medido -------------------------------------------- */

  // O enquadramento não está escrito em lado nenhum: mede-se. A peça ocupa uma
  // parte diferente da imagem em cada produto — uma estante alta enche-a, um
  // banco fica no fundo — e afinar percentagens à mão só funcionaria no ISLET.
  // Desenha-se a imagem pequena num canvas, procura-se onde o fundo de estúdio
  // deixa de ser liso, e centra-se a janela de corte nesse conteúdo.
  var medidas = {};
  function medir(url) {
    if (medidas[url]) return medidas[url];
    medidas[url] = new Promise(function (ok) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var L = 140, c = document.createElement('canvas');
          var A = im.naturalWidth / im.naturalHeight;
          c.width = L; c.height = Math.max(1, Math.round(L / A));
          var g = c.getContext('2d', { willReadFrequently: true });
          g.drawImage(im, 0, 0, c.width, c.height);
          var d = g.getImageData(0, 0, c.width, c.height).data;
          function pix(x, y) { var i = (y * c.width + x) * 4; return (d[i] + d[i + 1] + d[i + 2]) / 3; }
          var x0 = c.width, x1 = 0, y0 = c.height, y1 = 0, achou = false;
          for (var y = 0; y < c.height; y++) {
            var ant = pix(0, y);
            for (var x = 1; x < c.width; x++) {
              var v = pix(x, y);
              if (Math.abs(v - ant) > 9) {
                achou = true;
                if (x < x0) x0 = x; if (x > x1) x1 = x;
                if (y < y0) y0 = y; if (y > y1) y1 = y;
              }
              ant = v;
            }
          }
          // A cor do fundo do estúdio, lida no topo da imagem. É por causa dela
          // que a página muda de cor: o render é neutro (#ececec no ISLET) e o
          // papel do tema é mais claro e mais quente, e a emenda via-se.
          var sr = 0, sg = 0, sb = 0, n = 0;
          for (var yy = 0; yy < Math.max(2, (c.height * 0.08) | 0); yy++) {
            for (var xx = 0; xx < c.width; xx += 2) {
              var k = (yy * c.width + xx) * 4;
              sr += d[k]; sg += d[k + 1]; sb += d[k + 2]; n++;
            }
          }
          var fundo = n ? [Math.round(sr / n), Math.round(sg / n), Math.round(sb / n)] : null;

          // A cor da PECA: media dos pixeis que se afastam do fundo do estudio.
          // E o que permite pintar uma bolinha de cor sem depender de amostra
          // nenhuma — a cor sai da fotografia da propria variante.
          var cr = 0, cg = 0, cb = 0, cn = 0;
          if (fundo) {
            for (var q = 0; q < d.length; q += 4) {
              var dd = Math.abs(d[q] - fundo[0]) + Math.abs(d[q+1] - fundo[1]) + Math.abs(d[q+2] - fundo[2]);
              if (dd > 60) { cr += d[q]; cg += d[q+1]; cb += d[q+2]; cn++; }
            }
          }
          var cor = cn > 12 ? [Math.round(cr / cn), Math.round(cg / cn), Math.round(cb / cn)] : null;
          ok(achou ? {
                fundo: fundo,
                cor: cor,
                cx: (x0 + x1) / 2 / c.width,
                cy: (y0 + y1) / 2 / c.height,
                // fracção da altura da imagem que a peça ocupa: é isto, e não
                // a proporção da peça, que decide se ela cabe na moldura
                fh: Math.max((y1 - y0) / c.height, 0.02),
                // e a largura, que a prova precisa para a peca encher o quadro
                fw: Math.max((x1 - x0) / c.width, 0.02),
                A: A
              } : { fundo: fundo, cor: cor, cx: 0.5, cy: 0.5, fh: 1, fw: 1, A: A });
        } catch (e) { ok({ cx: 0.5, cy: 0.5, fh: 1, fw: 1, A: im.naturalWidth / im.naturalHeight }); }
      };
      im.onerror = function () { ok({ cx: 0.5, cy: 0.5, fh: 1, fw: 1, A: 1 }); };
      im.src = url;
    });
    return medidas[url];
  }

  // Com object-fit:cover, a fracção visível do original depende das duas
  // proporções; a percentagem que centra o conteúdo sai daí, não de tentativa.
  function enquadrar(img) {
    var url = img.getAttribute('src');
    medir(url).then(function (m) {
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var Ab = r.width / r.height, As = m.A || 1;
      function pos(centro, visivel) {
        if (visivel >= 1) return 50;
        var p = (centro - visivel / 2) / (1 - visivel);
        return Math.max(0, Math.min(1, p)) * 100;
      }
      var px = 50, py = 50;
      if (Ab > As) py = pos(m.cy, As / Ab);
      else px = pos(m.cx, Ab / As);
      img.style.objectPosition = px.toFixed(1) + '% ' + py.toFixed(1) + '%';

      // A aresta de baixo da fotografia era uma linha dura: o chao do render
      // esta nos 203 de cinzento e a pagina nos 237, e o encontro dos dois
      // lia-se como uma faixa colada por cima da pagina. Dissolve-se — mas so
      // por baixo de onde a peca acaba, que o codigo ja sabe medir. Uma
      // percentagem escolhida a olho cortava os pes de metade do catalogo.
      if (img.closest('[data-pdp2-palco],[data-pdp2-espelho-foto]')) {
        var fim = m.cy + m.fh / 2;            // onde a peca acaba, no original
        if (Ab > As) {                        // ha corte na vertical
          var visivel = As / Ab;
          fim = (fim - py / 100 * (1 - visivel)) / visivel;
        }
        var inicio = Math.min(1, Math.max(0.78, fim + 0.03));
        img.style.setProperty('--pdp2-fade', inicio >= 0.985 ? '100%' : (inicio * 100).toFixed(1) + '%');
      }
    });
  }

  function enquadrarTodas() {
    raiz.querySelectorAll('[data-pdp2-palco] img, [data-pdp2-tira] img').forEach(enquadrar);
  }
  var arRedim;
  window.addEventListener('resize', function () {
    clearTimeout(arRedim); arRedim = setTimeout(enquadrarTodas, 200);
  });

  /* ---- pintar ---------------------------------------------------------- */

  var elPreco = raiz.querySelector('[data-pdp2-preco]');
  var elBarraP = raiz.querySelector('[data-pdp2-barra-preco]');
  var elBarraS = raiz.querySelector('[data-pdp2-barra-sel]');
  var elCompP = raiz.querySelector('[data-pdp2-comprar-preco]');
  var elCompS = raiz.querySelector('[data-pdp2-comprar-sel]');

  // A barra fixa existe para dar acesso ao botao quando ele nao esta a vista.
  // Com o botao dentro da escolha, havia dois "Adicionar ao carrinho" no mesmo
  // ecra — e o de baixo, espremido entre o preco cortado e a bolha do WhatsApp,
  // era o feio dos dois. A barra recolhe enquanto o verdadeiro estiver visivel.
  (function esconderBarraQuandoHaBotao() {
    var alvo = raiz.querySelector('.pdp2-comprar');
    var barra = document.querySelector('.pdp2-barra');
    if (!alvo || !barra || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entradas) {
      barra.classList.toggle('pdp2-barra--recolhida', entradas[0].isIntersecting);
    }, { rootMargin: '-10px 0px -80px 0px' }).observe(alvo);
  })();
  var elVid = raiz.querySelector('[data-pdp2-vid]');
  var elTira = raiz.querySelector('[data-pdp2-tira]');
  var elHeroi = raiz.querySelector('[data-pdp2-heroi]');
  var elPalco = raiz.querySelector('[data-pdp2-palco]');
  var elConta = raiz.querySelector('[data-pdp2-conta]');
  var foto = 0, fotosActuais = [], descActual = '';
  var elCotadas = raiz.querySelector('[data-pdp2-cotadas]');
  var elEsp = raiz.querySelector('[data-pdp2-espelho]');
  var elEspFoto = raiz.querySelector('[data-pdp2-espelho-foto]');
  var elEspL = raiz.querySelector('[data-pdp2-espelho-l]');
  var eixoMudado = -1;
  var elNota = raiz.querySelector('[data-pdp2-tira-nota]');

  var arrancou = false;

  function pintar() {
    var v = variante(sel);
    if (v) {
      if (elVid) elVid.value = v.id;
      if (elPreco && elPreco.childNodes[0]) elPreco.childNodes[0].nodeValue = v.p;
      if (elBarraP) elBarraP.textContent = v.p;
      if (elCompP) elCompP.textContent = v.p;
    }
    if (elBarraS) elBarraS.textContent = temEixos ? sel.join(' · ') : '';
    if (elCompS) elCompS.textContent = temEixos ? sel.join(' · ') : '';

    if (elTira || elPalco) {
      var fotos = imagens(eixoMudado);
      var desc = (temEixos && fotos.sel) ? emSel(D.titulo, fotos.sel) : D.titulo;
      var mudou = fotos.urls.join('|') !== fotosActuais.join('|');
      fotosActuais = fotos.urls;
      descActual = desc;
      if (mudou) foto = 0;
      mostrarFoto(mudou);
      if (elNota) {
        if (fotos.exacto || !fotos.sel) {
          elNota.hidden = true;
        } else {
          var i = eixoDe(fotos.cedeu);
          elNota.hidden = false;
          // "o madeira Madeira Nogueira" — o nome do eixo ja vem dentro do
          // valor em algumas opcoes. Diz-se o valor e mais nada.
          elNota.textContent = tr('foto_nota', { a: fotos.sel[i], b: sel[i] });
        }
      }
    }

    if (elCotadas) {
      // As cotadas vivem na galeria do produto e a legenda diz a que variante
      // pertencem: o ECHO tem uma para QUEEN e outra para KING, o IMPERIUM uma
      // para 180 e outra para 220. Se alguma legenda nomear a escolha actual,
      // mostram-se só essas; se nenhuma nomear, mostram-se todas.
      function chave(t) { return String(t).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
      var todas = D.cotadas || [];
      var marcadas = todas.filter(function (c) {
        var a = chave(c.alt);
        return sel.some(function (v, j) { return v && (a.indexOf(chave(v)) >= 0 || a.indexOf(chave(comoPT(j, v))) >= 0); });
      });
      var conj = (marcadas.length ? marcadas : todas).map(function (c) { return c.url; });
      if (!conj.length) conj = null;
      // Com os desenhos da própria peça (custom.cad_desenhos) as cotadas antigas
      // saem: foram feitas sobre outras versões e trazem números que já não são
      // os do modelo (a LINE diz 850 de altura, o modelo 860). Uma página não
      // pode dizer dois números para a mesma cota. `estudio: true` no JSON
      // devolve-as, se um dia forem refeitas a partir do modelo.
      if (D.cad && D.cad.vistas && !D.cad.estudio) conj = null;
      // O desenho em PDF: outro artefacto, outro publico. Quem projecta quer
      // levar as cotas para o desenho dele, nao le-las no telemovel.
      var elBaixar = raiz.querySelector('[data-pdp2-baixar]');
      if (elBaixar) {
        var pdf = null;
        for (var z = 0; z < sel.length; z++) {
          if ((D.desenhos || {})[sel[z]]) { pdf = D.desenhos[sel[z]]; break; }
        }
        if (pdf) {
          elBaixar.hidden = false;
          elBaixar.innerHTML = '<a href="' + esc(pdf) + '" download>' + esc(tr('baixar_pdf')) + '</a>';
        } else {
          elBaixar.hidden = true;
          elBaixar.innerHTML = '';
        }
      }

      // Os desenhos da galeria ficam em segundo plano, numa fila pequena no fim
      // da secção. Já não escondem os números: antes, havendo cotadas, a lista
      // desaparecia e sobrava só a fotografia.
      var elEstudio = raiz.querySelector('[data-pdp2-estudio]');
      if (elEstudio) elEstudio.hidden = !(conj && conj.length);
      if (conj && conj.length) {
        elCotadas.hidden = false;
        elCotadas.innerHTML = conj.map(function (u, i) {
          return '<button type="button" class="pdp2-cotada" data-pdp2-zoom="' + esc(u) + '">' +
            '<img src="' + esc(u) + '" loading="lazy" alt="' + esc(tr('cotada_alt', { t: D.titulo, i: i + 1, n: conj.length })) + '">' +
            '</button>';
        }).join('');
        // A nota fica fora da fila: no telemovel a fila desliza de lado, e a
        // nota ia com ela.
        var notaCot = elCotadas.nextElementSibling;
        if (!notaCot || !notaCot.classList.contains('pdp2-cotadas__nota')) {
          notaCot = document.createElement('p');
          notaCot.className = 'pdp2-cotadas__nota';
          notaCot.textContent = tr('cotadas_nota');
          elCotadas.insertAdjacentElement('afterend', notaCot);
        }
        notaCot.hidden = false;
      } else {
        elCotadas.hidden = true;
        elCotadas.innerHTML = '';
        var semNota = elCotadas.nextElementSibling;
        if (semNota && semNota.classList.contains('pdp2-cotadas__nota')) semNota.hidden = true;
      }
    }

    raiz.querySelectorAll('[data-pdp2-sw]').forEach(function (b) {
      b.setAttribute('aria-pressed', sel[+b.dataset.eixo] === b.dataset.valor ? 'true' : 'false');
    });
    pintarBarraAmostras();
    // O palco 3D da pagina vive noutro bloco deste ficheiro: diz-se-lhe o que
    // esta escolhido, e ele troca o modelo e as fotografias da variante.
    var vEsc2 = variante(sel);
    var mEsc = (D.modelos || []).length ? modeloDaEscolha() : null;
    raiz._pdp2Escolha = { variante: vEsc2 ? String(vEsc2.id) : '', modelo: mEsc ? mEsc.src : '' };
    raiz.dispatchEvent(new CustomEvent('pdp2:escolha', { detail: raiz._pdp2Escolha }));
    raiz.querySelectorAll('[data-pdp2-eixo]').forEach(function (bloco) {
      var i = +bloco.dataset.pdp2Eixo;
      var nome = bloco.querySelector('[data-pdp2-eixo-n]');
      if (nome) nome.firstChild.nodeValue = sel[i];
      var am = bloco.querySelector('[data-pdp2-amostra]');
      var url = (swatches[nomes[i]] || {})[sel[i]];
      // Sem amostra — um tamanho, ou uma cor sem textura no PIM — o quadrado
      // ficava vazio, a mostrar uma cor que nao existe. Passa a mostrar a
      // fotografia da variante escolhida; sem fotografia, sai.
      var vEsc = url ? null : variante(sel);
      var fotoV = vEsc && vEsc.img;
      if (am) {
        am.style.backgroundImage = url ? 'url(' + emLargura(url, 340) + ')' : (fotoV ? 'url(' + emLargura(fotoV, 340) + ')' : '');
        am.classList.toggle('pdp2-eixo__amostra--foto', !url && !!fotoV);
        am.hidden = !url && !fotoV;
      }
      var pp = bloco.querySelector('[data-pdp2-pp]');
      if (pp) pp.hidden = petproof.indexOf(sel[i]) < 0;
    });

    // O espelho diz por palavras o que a fotografia pequena nao consegue dizer:
    // entre o Savana e o Ambar, ou entre dois veludos, a imagem quase nao muda,
    // mas o nome muda sempre. O que acabou de mudar acende devagar e apaga-se —
    // e uma confirmacao, nao um truque.
    if (elEsp && elEspL) {
      elEsp.hidden = false;
      // a altura do bloco preso serve a margem de rolagem dos seletores
      raiz.style.setProperty('--pdp2-espelho-h', Math.round(elEsp.getBoundingClientRect().height) + 'px');
      elEspL.innerHTML = (D.opcoes || []).map(function (o, i) {
        return '<span class="pdp2-espelho__v' + (i === eixoMudado ? ' pdp2-espelho__v--novo' : '') + '">' +
          esc(sel[i]) + '</span>';
      }).join('<i>·</i>');
      if (eixoMudado >= 0) {
        var aceso = elEspL.querySelector('.pdp2-espelho__v--novo');
        if (aceso) setTimeout(function () { aceso.classList.remove('pdp2-espelho__v--novo'); }, 1400);
        eixoMudado = -1;
      }
    }
  }

  /* ---- as amostras na barra fixa ---------------------------------------- */

  // A imagem de uma opcao: a cena dessa variante (um ambiente cuja legenda
  // nomeie a opcao), senao a amostra declarada, senao a fotografia de uma
  // variante com essa opcao — de preferencia a que mantem o resto da escolha.
  function imagemDaOpcao(i, val) {
    var cena = (D.media || []).filter(function (m) {
      return eAmbiente(m.url) && m.alt && (m.alt.indexOf(val) >= 0 || m.alt.indexOf(comoPT(i, val)) >= 0);
    })[0];
    if (cena) return cena.url;
    var sw = (swatches[nomes[i]] || {})[val];
    if (sw) return sw;
    var tentativa = sel.slice(); tentativa[i] = val;
    var v = variante(tentativa);
    if (!v || !v.img) v = (D.variantes || []).filter(function (x) { return x.o[i] === val && x.img; })[0];
    return v ? v.img : '';
  }

  var elBarraSw = raiz.querySelector('[data-pdp2-barra-sw]');
  function pintarBarraAmostras() {
    if (!elBarraSw || !temEixos) return;
    elBarraSw.hidden = false;
    elBarraSw.innerHTML = (D.opcoes || []).map(function (o, i) {
      var medida = eixoDeMedida(i);
      return (i ? '<i class="pdp2-barra__sep" aria-hidden="true"></i>' : '') + o.valores.map(function (val) {
        var tentativa = sel.slice(); tentativa[i] = val;
        var existe = !!variante(tentativa);
        var atr = ' type="button" data-pdp2-barra-am data-eixo="' + i + '" data-valor="' + esc(val) + '"' +
          ' aria-pressed="' + (sel[i] === val) + '" aria-label="' + esc(o.nome + ': ' + val) + '"' +
          (existe ? '' : ' disabled');
        if (medida) return '<button class="pdp2-barra__am pdp2-barra__am--txt"' + atr + '>' + esc(val) + '</button>';
        var img = imagemDaOpcao(i, val);
        return '<button class="pdp2-barra__am"' + atr + '>' +
          (img ? '<img src="' + esc(emLargura(img, 120)) + '" alt="" loading="lazy">' : '') + '</button>';
      }).join('');
    }).join('');
    var barraEl = elBarraSw.closest('.pdp2-barra');
    if (barraEl) barraEl.classList.add('pdp2-barra--com-amostras');
  }
  // O nome da opcao sobe por cima da bolinha com o rato em cima. Vive fora da
  // fila das amostras, que rola de lado e cortaria qualquer coisa que saisse
  // dela. No telemovel nao ha rato: tocar abre o configurador, que diz o nome.
  var elBarraNome = raiz.querySelector('[data-pdp2-barra-nome]');
  if (elBarraSw && elBarraNome && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    elBarraSw.addEventListener('mouseover', function (e) {
      var b = e.target.closest('[data-pdp2-barra-am]');
      if (!b) return;
      var caixaNome = elBarraNome.parentNode.getBoundingClientRect();
      var r = b.getBoundingClientRect();
      elBarraNome.textContent = b.dataset.valor;
      elBarraNome.style.left = (r.left + r.width / 2 - caixaNome.left) + 'px';
      elBarraNome.classList.add('e-visivel');
    });
    elBarraSw.addEventListener('mouseleave', function () { elBarraNome.classList.remove('e-visivel'); });
    elBarraSw.addEventListener('scroll', function () { elBarraNome.classList.remove('e-visivel'); }, { passive: true });
  }

  if (elBarraSw) elBarraSw.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pdp2-barra-am]');
    if (!b || b.disabled) return;
    var i = +b.dataset.eixo, tentativa = sel.slice();
    tentativa[i] = b.dataset.valor;
    if (!variante(tentativa)) return;
    sel = tentativa;
    eixoMudado = i;
    pintar();
    // Como as amostras da pagina: tocar leva ao configurador, onde a peca se
    // ve grande na opcao que se acabou de escolher.
    abrirProva();
  });

  /* ---- o herói --------------------------------------------------------- */

  // Uniformizar não é impor a mesma moldura a peças de feitios opostos: uma
  // faixa 21:9 numa estante alta corta-a de cima e de baixo. O herói mantém a
  // linguagem — uma fotografia, setas, contador — e deixa a altura seguir a
  // peça, entre 3:2 e 21:9.
  // A página passa a viver no fundo do próprio render, para o herói não ter
  // uma emenda por cima. O papel do tema é #f7f7f4, mais claro e mais quente do
  // que o estúdio; a diferença via-se numa linha a toda a largura.
  var fundoPosto = false;
  var propPosta = false;
  function tomarFundo(m) {
    // Na ficha escura o papel e uma decisao, nao uma leitura: sem isto o fundo
    // do render de estudio acendia a pagina toda de volta.
    if (raiz.classList.contains('pdp2--noite')) return;
    if (fundoPosto || !m.fundo) return;
    var f = m.fundo;
    // só se for mesmo um fundo de estúdio claro e neutro
    if (Math.min.apply(null, f) < 200) return;
    if (Math.max.apply(null, f) - Math.min.apply(null, f) > 14) return;
    fundoPosto = true;
    raiz.style.setProperty('--papel', 'rgb(' + f.join(',') + ')');
    raiz.style.setProperty('--areia', 'rgb(' + f.map(function (v) {
      return Math.max(0, Math.round(v * 0.955));
    }).join(',') + ')');
  }

  function ajustarAltura(url) {
    if (!elHeroi) return;
    medir(url).then(function (m) {
      tomarFundo(m);
      // Com object-fit:cover, a fracção da altura do original que se vê é
      // As/Ab. Para a peça caber inteira basta que essa fracção não seja menor
      // do que a altura que ela ocupa: Ab <= As / fh. Não é palpite, é a conta.
      var limite = (m.A || 1) / m.fh;
      // No telemovel a caixa e estreita: uma proporcao alta da uma tira, e uma
      // baixa da uma foto que ocupa o ecra todo. Aperta-se o intervalo.
      var estreito = window.matchMedia('(max-width: 759px)').matches;
      var a = estreito
        ? Math.max(1.05, Math.min(1.75, limite * 0.99))
        : Math.max(1.15, Math.min(2.34, limite * 0.99));
      elHeroi.style.setProperty('--pdp2-heroi-prop', a.toFixed(3));
      // A caixa da escolha mede-se UMA vez e nao volta a mexer. As seis vistas
      // tem enquadramentos muito diferentes — uma e a peca ao longe, outra e um
      // grande plano do tabuleiro — e uma caixa que se ajusta a cada imagem
      // cresce e encolhe a cada escolha. Fica pela primeira, que e a vista de
      // frente, e as outras arrumam-se la dentro.
      if (!propPosta) {
        propPosta = true;
        raiz.style.setProperty('--pdp2-peca-prop', a.toFixed(3));
      }
    });
  }

  // Com a caixa de tamanho fixo, o intervalo entre trocar a fotografia e a nova
  // chegar lia-se como um rectangulo cinzento. A anterior fica ate a seguinte
  // estar pronta — se ja estiver em cache, a troca e imediata na mesma.
  function pintarQuandoPronta(caixa, url, alt) {
    var nova = new Image();
    var posta = false;
    function por() {
      if (posta) return;
      posta = true;
      caixa.innerHTML = '';
      caixa.appendChild(nova);
      enquadrar(nova);
    }
    nova.alt = alt || '';
    nova.onload = por;
    nova.onerror = por;
    nova.src = url;
    if (nova.complete && nova.naturalWidth) por();
  }

  function mostrarFoto(animar) {
    if (!fotosActuais.length) {
      if (elPalco) elPalco.innerHTML = '';
      if (elTira) elTira.innerHTML = '';
      if (elConta) elConta.textContent = '';
      return;
    }
    foto = (foto % fotosActuais.length + fotosActuais.length) % fotosActuais.length;

    if (elPalco) {
      elPalco.innerHTML = '<img src="' + esc(fotosActuais[foto]) + '" alt="' + esc(descActual) + '">';
      var im = elPalco.querySelector('img');
      im.classList.add('pdp2-entra');
      ajustarAltura(fotosActuais[foto]);
      enquadrar(im);
    }
    if (elEspFoto) pintarQuandoPronta(elEspFoto, fotosActuais[foto], descActual);
    if (elTira) {
      elTira.innerHTML = fotosActuais.map(function (u, i) {
        // `data-pdp2-zoom` e a peca que a lupa da pagina ja escuta; nao ha
        // handler novo, so o atributo certo.
        return '<button type="button" class="pdp2-mini" data-pdp2-zoom="' + esc(u) + '"' +
          ' aria-label="' + esc(tr('ver_foto_n', { i: i + 1, n: fotosActuais.length })) + '">' +
          // A miniatura tem 161 px e o render tem 2000: uma delas pesava 542 KB.
          // O `data-pdp2-zoom` acima continua a apontar para o original, que e o
          // que a lupa abre.
          // 800 e nao 400: num ecra de densidade 2 uma vista de 330 px pedia 660
          '<img src="' + esc(emLargura(u, 800)) + '" alt="' + esc(descActual) + '" loading="lazy"></button>';
      }).join('');
      // Na composicao cada vista tem de encher o seu quadro: `enquadrar` so
      // centra a peca, e com renders quadrados isso deixa metade do azulejo em
      // estudio vazio. `encherQuadro` amplia-a ate encher, sem a cortar.
      elTira.querySelectorAll('img').forEach(encherQuadro);
    }
    if (elConta) elConta.textContent = (foto + 1) + ' / ' + fotosActuais.length;
    raiz.querySelectorAll('[data-pdp2-ant],[data-pdp2-seg]').forEach(function (b) {
      b.hidden = fotosActuais.length < 2;
    });
  }

  function passar(d) { foto += d; mostrarFoto(true); }

  var elAnt = raiz.querySelector('[data-pdp2-ant]'), elSeg = raiz.querySelector('[data-pdp2-seg]');
  if (elAnt) elAnt.addEventListener('click', function () { passar(-1); });
  if (elSeg) elSeg.addEventListener('click', function () { passar(1); });
    if (elHeroi) elHeroi.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { passar(-1); e.preventDefault(); }
    if (e.key === 'ArrowRight') { passar(1); e.preventDefault(); }
  });

  /* ---- construir a escolha --------------------------------------------- */

  // Um eixo e de medidas quando os seus valores trazem numeros e unidades.
  function eixoDeMedida(i) {
    var o = (D.opcoes || [])[i];
    if (!o) return false;
    // pelos valores em PT: uma traducao nao pode fazer de uma medida uma cor
    var vals = o.valores.map(function (v) { return comoPT(i, v); });
    var comNumero = vals.filter(function (v) { return /\d/.test(v); }).length;
    return comNumero === vals.length && /cm|mm|Ø|m\b|"/i.test(vals.join(' '));
  }

  // Sem amostra declarada, a cor da bolinha le-se na fotografia da variante:
  // a cor dominante da peca, ignorando o fundo branco do estudio.
  function pintarSemAmostra() {
    raiz.querySelectorAll('.pdp2-swatch--sem:not(.pdp2-swatch--medida)').forEach(function (b) {
      var i = +b.dataset.eixo, tentativa = sel.slice();
      tentativa[i] = b.dataset.valor;
      var v = variante(tentativa) || (D.variantes || []).filter(function (x) { return x.o[i] === b.dataset.valor; })[0];
      if (!v || !v.img || b.dataset.pinta) return;
      b.dataset.pinta = '1';
      medir(v.img).then(function (m) {
        if (m && m.cor) b.style.backgroundColor = 'rgb(' + m.cor.join(',') + ')';
      });
    });
  }

  function montarOpcoes() {
    var alvo = raiz.querySelector('[data-pdp2-opcoes]');
    if (!alvo) return;
    alvo.innerHTML = (D.opcoes || []).map(function (o, i) {
      var sw = swatches[o.nome] || {};
      var temPP = o.valores.some(function (v) { return petproof.indexOf(v) >= 0; });
      // largura proporcional ao numero de valores, com tecto: senao um eixo de
      // dez tecidos e outro de duas madeiras repartiam o espaco a meias
      var peso = Math.min(Math.max(o.valores.length, 1), 6);
      var medidaNoEixo = eixoDeMedida(i);
      return '<div data-pdp2-eixo="' + i + '" style="flex-grow:' + peso + '">' +
        '<p class="pdp2-eixo__r">' + esc(o.nome) + '</p>' +
        '<div class="pdp2-eixo__topo">' +
          '<span class="pdp2-eixo__amostra" data-pdp2-amostra></span>' +
          '<p class="pdp2-eixo__n" data-pdp2-eixo-n>&nbsp;' +
            '<span class="pdp2-eixo__pp" data-pdp2-pp hidden>' + ({pt:'Para animais',en:'Pet-friendly',es:'Antimanchas'}[(document.documentElement.lang||'pt').slice(0,2)]||'Para animais') + '</span>' +
          '</p>' +
        '</div>' +
        '<div class="pdp2-swatches' + (eixoDeMedida(i) ? ' pdp2-swatches--medida' : '') + '">' + o.valores.map(function (v) {
          var pp = petproof.indexOf(v) >= 0;
          // Um eixo de medidas nao e uma cor: a bolinha fica, com a medida
          // escrita dentro. Sem amostra e sem ser medida, a bolinha ganha a cor
          // verdadeira da peca, lida da fotografia daquela variante.
          var medida = eixoDeMedida(i);
          if (medida) {
            return '<button type="button" class="pdp2-medida"' +
              ' data-pdp2-sw data-eixo="' + i + '" data-valor="' + esc(v) + '"' +
              ' aria-pressed="false">' + esc(v) + '</button>';
          }
          return '<button type="button" class="pdp2-swatch' + (pp ? ' pdp2-swatch--pp' : '') +
            (sw[v] ? '' : ' pdp2-swatch--sem') + '"' +
            ' data-pdp2-sw data-eixo="' + i + '" data-valor="' + esc(v) + '"' +
            ' aria-pressed="false" title="' + esc(v) + '" aria-label="' + esc(v) + '"' +
            (sw[v] ? ' style="background-image:url(' + esc(emLargura(sw[v], 160)) + ')"' : '') + '>' +
            '</button>';
        }).join('') + '</div>' +
        (temPP ? '<p class="pdp2-nota-pp"><i></i>' + esc(tr('petproof_nota')) + '</p>' : '') +
        // O rótulo do eixo está uma linha acima, por isso o botão não precisa de o
        // repetir — e assim também não precisa de acertar género nem plural. A
        // regra anterior colava um "s" ao nome do eixo e dizia "ver os cors".
        // Num eixo de medidas não há nada para ver de perto: não há amostra.
        (medidaNoEixo ? '' :
          '<p class="pdp2-ver"><button type="button" data-pdp2-ver="' + i + '"' +
          ' aria-label="' + esc(tr('ver_de_perto') + ': ' + o.nome) + '">' + esc(tr('ver_de_perto')) + '</button></p>') +
        '</div>';
    }).join('');

    pintarSemAmostra();

    alvo.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp2-sw]');
      if (!b) return;
      var i = +b.dataset.eixo, tentativa = sel.slice();
      tentativa[i] = b.dataset.valor;
      if (!variante(tentativa)) return;
      sel = tentativa;
      eixoMudado = i;
      eixoProva = i;
      pintar();
      // O primeiro toque leva para a prova: e la que se ve a peca sem ela sair
      // do ecra. Os toques seguintes ja acontecem la dentro.
      abrirProva();
    });
  }

  /* ---- ver os materiais de perto --------------------------------------- */

  // Não se pede uma amostra: vê-se. As texturas do PIM são macros de 1 600 px,
  // que é o que substitui o toque — a investigação diz que a imagem de textura
  // é a categoria mais crítica numa peça feita por encomenda. O visor mostra o
  // material a toda a largura, a peça feita nele ao lado, e escolhe-o de facto:
  // não é uma galeria, é a escolha em tamanho real.
  var visor = raiz.querySelector('[data-pdp2-visor]');
  var visorEixo = 0, visorIdx = 0;

  function pecaEm(eixo, valor) {
    var itens = (D.combos && D.combos.items) || [];
    var alvo = sel.slice(); alvo[eixo] = valor;
    var achado = itens.filter(function (it) {
      return Object.keys(it.sel || {}).every(function (e) {
        var i = eixoDe(e);
        return i < 0 || alvo[i] === it.sel[e];
      });
    })[0];
    return achado ? achado.url : null;
  }

  // A identidade dos materiais vive na pagina das amostras (37 materiais, com a
  // coleccao e a referencia do fornecedor). Le-se de la e nao daqui: um tecido
  // nao pode chamar-se PETRUS 4 numa pagina e outra coisa na outra. Carrega-se
  // so quando o visor abre pela primeira vez, e se falhar o visor fica como
  // estava — a identidade e um acrescento, nao um requisito.
  var amostras = null, amostrasPedidas = false;

  // Ha um tecido "Sand" e uma pele "Sand". Casar material com opcao pelo nome
  // solto dava a referencia da pele a quem estava a olhar para o tecido — errado
  // e mudo, que e o pior dos dois. Casa-se pelo eixo: cada eixo da ficha diz em
  // que seccao das amostras se procura.
  var EIXO_SECCAO = {
    'tecido': 'tecidos', 'revestimento': 'tecidos',
    'pele': 'peles', 'eco-pele': 'peles',
    'tampo': 'pedras',
    'madeira': 'madeiras', 'base': 'madeiras',
    'lacado': 'lacados', 'composição': 'lacados', 'composicao': 'lacados',
    'metal': 'metais', 'puxador': 'metais'
  };

  function carregarAmostras() {
    if (amostrasPedidas || !D.amostras) return;
    amostrasPedidas = true;
    fetch(D.amostras).then(function (r) { return r.json(); }).then(function (j) {
      amostras = { seccoes: {}, quantos: {}, solto: {} };
      (j.secoes || []).forEach(function (sec) {
        var k = sec.k || '';
        amostras.seccoes[k] = amostras.seccoes[k] || {};
        (sec.grupos || []).forEach(function (g) {
          (g.m || []).forEach(function (m) {
            var reg = { grupo: g.grupo || '', ref: m.ref || '', nota: g.nota || '' };
            amostras.seccoes[k][m.n] = reg;
            amostras.quantos[m.n] = (amostras.quantos[m.n] || 0) + 1;
            amostras.solto[m.n] = reg;
          });
        });
      });
      if (visor && !visor.hidden) pintarVisor();
    }).catch(function () { amostras = {}; });
  }

  // As madeiras vem escritas em maiusculas de catalogo — "MDF REVESTIDO A
  // NOGUEIRA NATURAL". Numa ficha isso e um grito.
  function baixinho(t) {
    var x = String(t || '').trim().replace(/^\|\s*/, '').replace(/\s*\|\s*/g, ' · ');
    if (!x || x !== x.toUpperCase()) return x;
    // Baixam-se as palavras. As siglas (MDF, RAL, NCS) e os codigos com numeros
    // ficam como estao: "Mdf revestido" e "Ral 1013" sao piores que o grito.
    var out = x.split(' ').map(function (w) {
      var letras = w.replace(/[^A-Za-zÀ-ÿ]/g, '').length;
      if (/\d/.test(w) || (letras >= 2 && letras <= 3)) return w;
      return w.toLowerCase();
    }).join(' ');
    return out.charAt(0).toUpperCase() + out.slice(1);
  }

  function acharMaterial(eixo, val) {
    if (!amostras) return null;
    // As amostras e as seccoes (EIXO_SECCAO) estao em PT; em /en e /es o eixo
    // e o valor chegam traduzidos e voltam ao PT pela posicao.
    if (PT) {
      var ie = eixoDe(eixo);
      if (ie >= 0) { val = PT.val(ie, val); eixo = PT.nomes[ie]; }
    }
    var k = EIXO_SECCAO[String(eixo || '').toLowerCase().trim()];
    // Eixo conhecido: procura-se so na seccao dele. Nao estar la e nao ter
    // identidade — nao e motivo para ir procurar noutro sitio.
    if (k) return (amostras.seccoes[k] || {})[val] || null;
    // Eixo que ninguem mapeou: so se o nome for unico em todo o ficheiro.
    return amostras.quantos[val] === 1 ? amostras.solto[val] : null;
  }

  function identidade(eixo, val) {
    var a = acharMaterial(eixo, val);
    if (!a) return '';
    var linhas = [];
    if (a.grupo) linhas.push('<p class="pdp2-visor__col">' + esc(a.grupo) + '</p>');
    if (a.nota) linhas.push('<p class="pdp2-visor__nota">' + esc(a.nota) + '</p>');
    else if (a.ref && !a.grupo) linhas.push('<p class="pdp2-visor__nota">' + esc(baixinho(a.ref)) + '</p>');
    if (a.ref && a.grupo) linhas.push('<p class="pdp2-visor__ref">ref. ' + esc(a.ref) + '</p>');
    return linhas.join('');
  }

  function pintarVisor() {
    if (!visor) return;
    var o = D.opcoes[visorEixo];
    var vals = o.valores;
    visorIdx = (visorIdx % vals.length + vals.length) % vals.length;
    var val = vals[visorIdx];
    var tex = (swatches[o.nome] || {})[val];
    var foto = fotoVisor(tex);
    var peca = pecaEm(visorEixo, val);
    var pp = petproof.indexOf(val) >= 0;

    visor.innerHTML =
      '<div class="pdp2-visor__fundo' + (foto ? ' e-foto' : '') + '"' +
        (foto || tex ? ' style="background-image:url(' + esc(emLargura(foto || tex, foto ? Math.min(larguraVisor(), 2560) : larguraVisor())) + ')"' : '') + '></div>' +
      '<div class="pdp2-visor__barra">' +
        '<div class="pdp2-visor__id">' +
          '<p class="pdp2-visor__eixo">' + esc(o.nome) + '</p>' +
          '<p class="pdp2-visor__nome">' + esc(val) + '</p>' +
          identidade(o.nome, val) +
          (pp ? '<p class="pdp2-visor__pp">' + esc(tr('visor_pp')) + '</p>' : '') +
          '<button type="button" class="pdp2-btn" data-pdp2-escolher>' + esc(tr('escolher_v', { v: val })) + '</button>' +
        '</div>' +
        (peca ? '<img class="pdp2-visor__peca" src="' + esc(peca) + '" alt="' + esc(emSel(D.titulo, [val])) + '">' : '') +
      '</div>' +
      '<div class="pdp2-visor__fila">' + vals.map(function (v, i) {
        var t = (swatches[o.nome] || {})[v];
        return '<button type="button" class="pdp2-visor__am' + (i === visorIdx ? ' e-agora' : '') +
          '" data-pdp2-am="' + i + '" aria-label="' + esc(v) + '"' +
          (t ? ' style="background-image:url(' + esc(emLargura(t, 160)) + ')"' : '') + '></button>';
      }).join('') + '</div>' +
      '<button type="button" class="pdp2-visor__x" data-pdp2-fechar aria-label="' + esc(tr('fechar')) + '">' + esc(tr('fechar')) + '</button>' +
      '<button type="button" class="pdp2-visor__seta pdp2-visor__seta--ant" data-pdp2-vant aria-label="' + esc(tr('anterior')) + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<button type="button" class="pdp2-visor__seta pdp2-visor__seta--seg" data-pdp2-vseg aria-label="' + esc(tr('seguinte')) + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>';
    var im = visor.querySelector('.pdp2-visor__peca');
    if (im) enquadrar(im);
  }

  /* ---- a prova: escolher em ecra inteiro ------------------------------- */

  var prova = raiz.querySelector('[data-pdp2-prova]');

  /* ---- as vistas do configurador ---------------------------------------
     Nos candeeiros o configurador tem tudo, em chips numa fila: a peca em 3D
     (quando ha modelo), o ambiente (a cena do heroi e os renders de sala), as
     fotografias do fornecedor, e as medidas com a ficha tecnica. Quem esta a
     escolher nao tem de fechar o plano para ver se cabe ou quantos lumenes da.
     Nas outras pecas fica como estava: uma vista so, sem chips. */

  function ficheiro(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function eAmbiente(u) { var f = ficheiro(u); return f.indexOf('pdp2-cena') === 0 || f.indexOf('amb-') === 0; }
  function eFornecedor(u) { return ficheiro(u).indexOf('main_') === 0; }
  function eCotada(u) { return /^0[1-6]_/.test(ficheiro(u)); }

  // A nota minima por baixo da fotografia: o que ela mostra, quando nao e a
  // escolha — ou que essa opcao nao tem fotografia.
  function notaDaFoto(f) {
    if (!f || f.exacto) return '';
    if (f.semFoto) return tr('sem_foto_em', { v: f.semFoto });
    if (f.sel && f.cedeu) return tr('foto_em', { v: f.sel[eixoDe(f.cedeu)] });
    return '';
  }

  var modo = null, provaIdx = 0, vista3d = null, lib3dPedida = null, modelo3dSrc = '';

  var eixoProva = -1;
  function modosDaProva() {
    var fotos = imagens(eixoProva);
    var lista = [];
    if (!D.candeeiro) {
      lista.push({ id: 'fotos', nome: tr('modo_fotos'), urls: fotos.urls, fotos: fotos });
      return lista;
    }
    if ((D.modelos || []).length) lista.push({ id: '3d', nome: '3D' });
    // Os ambientes existem em dois formatos: a cena do heroi e deitada (2600 x
    // 1106) e a de cartao e de pe (885 x 1106). No computador mostram-se as
    // deitadas, no telemovel as de pe; cada uma no ecra para que foi feita.
    // Se so houver de um formato, mostra-se esse.
    var deitado = !window.matchMedia('(max-width: 759px)').matches;
    var ambTodas = [];
    if (D.cena) ambTodas.push({ url: D.cena, ar: 2600 / 1106 });
    (D.media || []).forEach(function (m) { if (eAmbiente(m.url)) ambTodas.push(m); });
    var ambFormato = ambTodas.filter(function (m) { return deitado ? (m.ar || 1) >= 1 : (m.ar || 1) < 1; });
    var amb = (ambFormato.length ? ambFormato : ambTodas).map(function (m) { return m.url; });
    if (amb.length) lista.push({ id: 'ambiente', nome: tr('modo_ambiente'), urls: amb });
    // As fotografias da escolha (a da variante, quando existe) — nos candeeiros
    // sao os packshots do fornecedor. Se a escolha nao tiver nenhuma, todos.
    var forn = fotos.urls.filter(eFornecedor);
    if (!forn.length) forn = (D.media || []).map(function (m) { return m.url; }).filter(eFornecedor);
    if (forn.length) lista.push({ id: 'fornecedor', nome: tr('modo_fornecedor'), urls: forn, fotos: fotos });
    var resto = (D.media || []).map(function (m) { return m.url; }).filter(function (u) {
      return !eAmbiente(u) && !eFornecedor(u) && !eCotada(u);
    });
    if (resto.length) lista.push({ id: 'galeria', nome: tr('modo_fotos'), urls: resto });
    if (raiz.querySelector('[data-pdp2-medidas]:not([hidden]), .pdp2-tec')) lista.push({ id: 'ficha', nome: tr('modo_ficha') });
    return lista;
  }

  // O modelo da escolha. Os candeeiros tem um GLB por variante, com o SKU no
  // nome (<handle>--<SKU>.glb), e o Shopify guarda esse nome no endereco.
  // Sem SKU no nome, fica a legenda com mais valores da escolha: a primeira
  // que tivesse um so valor trocava o tamanho (CUPULA Ø 40 / Cobre dava o
  // Ø 25 / Cobre) ou a serie (OPALA Mini / Branco dava o Standard Branco).
  function modeloDaEscolha() {
    var ms = D.modelos || [];
    if (!ms.length) return null;
    var v = variante(sel);
    if (v && v.sku) {
      var fim = '--' + String(v.sku).toLowerCase() + '.glb';
      for (var i = 0; i < ms.length; i++) {
        var f = String(ms[i].src || '').split('?')[0].toLowerCase();
        if (f.slice(-fim.length) === fim) return ms[i];
      }
    }
    var melhor = ms[0], pontos = 0;
    for (var k = 0; k < ms.length; k++) {
      var n = 0;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] && ms[k].alt && (ms[k].alt.indexOf(sel[j]) >= 0 || ms[k].alt.indexOf(comoPT(j, sel[j])) >= 0)) n++;
      }
      if (n > pontos) { melhor = ms[k]; pontos = n; }
    }
    return melhor;
  }

  // O model-viewer vive fora do innerHTML da prova: repintar a prova a cada
  // amostra nao o volta a descarregar, so muda de sitio (e de GLB, se a cor
  // tiver outro modelo).
  function palco3d(caixa) {
    var m = modeloDaEscolha();
    if (!m) return;
    if (!vista3d) {
      vista3d = document.createElement('model-viewer');
      vista3d.setAttribute('camera-controls', '');
      vista3d.setAttribute('disable-zoom', '');
      vista3d.setAttribute('touch-action', 'pan-y');
      vista3d.setAttribute('interaction-prompt', 'none');
      vista3d.setAttribute('environment-image', 'neutral');
      vista3d.setAttribute('exposure', '1');
      vista3d.setAttribute('tone-mapping', 'neutral');
      vista3d.setAttribute('shadow-intensity', '0');
      vista3d.setAttribute('camera-orbit', '20deg 78deg auto');
      vista3d.setAttribute('field-of-view', '30deg');
      vista3d.setAttribute('loading', 'eager');
      vista3d.className = 'pdp2-prova__3d';
    }
    if (modelo3dSrc !== m.src) { modelo3dSrc = m.src; vista3d.setAttribute('src', m.src); }
    // Realidade aumentada em tamanho real, como no palco da pagina. Os de teto
    // nao tem: o AR so pousa a peca no chao ou na parede.
    if (D.arLocal) {
      vista3d.setAttribute('ar', '');
      vista3d.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      vista3d.setAttribute('ar-scale', 'fixed');
      vista3d.setAttribute('ar-placement', D.arLocal);
      if (m.usdz) vista3d.setAttribute('ios-src', m.usdz); else vista3d.removeAttribute('ios-src');
    }
    vista3d.setAttribute('alt', m.alt || tr('vista_3d_de', { t: D.titulo }));
    caixa.appendChild(vista3d);
    if (!(window.customElements && customElements.get('model-viewer')) && !lib3dPedida) {
      // <script type="module"> e nao import(): ver a vista 3D no fim do ficheiro
      var lib = D.lib3d || '';
      if (lib.indexOf('//') === 0) lib = location.protocol + lib;
      lib3dPedida = document.createElement('script');
      lib3dPedida.type = 'module';
      lib3dPedida.src = lib;
      document.head.appendChild(lib3dPedida);
    }
  }

  // As medidas e a ficha tecnica: copiadas da pagina, sem os atributos data-
  // (a pagina procura-os com querySelector e encontraria a copia primeiro).
  // O desenho esta a largura que tem na pagina.
  function palcoFicha() {
    var fontes = [].slice.call(raiz.querySelectorAll('[data-pdp2-medidas]:not([hidden]), .pdp2-tec'))
      .filter(function (el) { return !prova.contains(el); });
    var caixa = document.createElement('div');
    caixa.className = 'pdp2-prova__ficha';
    fontes.forEach(function (el) {
      var c = el.cloneNode(true);
      [c].concat([].slice.call(c.querySelectorAll('*'))).forEach(function (n) {
        [].slice.call(n.attributes).forEach(function (at) {
          // os id ficam: o desenho de cotas preenche com url(#padrao), e sem
          // eles a porta e a peca saiam a preto
          if (at.name.indexOf('data-pdp2') === 0) n.removeAttribute(at.name);
        });
      });
      c.className = 'pdp2-prova__ficha-sec';
      caixa.appendChild(c);
    });
    return caixa;
  }

  function pintarProva() {
    if (!prova || prova.hidden) return;
    var modos = modosDaProva();
    var atual = modos.filter(function (m) { return m.id === modo; })[0] || modos[0];
    modo = atual ? atual.id : null;
    var v = variante(sel);

    var urls = (atual && atual.urls) || [];
    var n = urls.length;
    // A vista das fotografias da escolha segue a pagina (foto); as outras tem
    // o seu proprio contador.
    var segue = atual && atual.fotos;
    var idx = n ? (((segue ? foto : provaIdx) % n) + n) % n : 0;
    if (!segue) provaIdx = idx;
    var url = urls[idx];

    // Uma linha, e curta. A frase longa — "A fotografia mostra X. Ainda nao
    // fotografamos esta peca em Y." — nao cabe numa linha de telemovel, e uma
    // nota que quebra em duas empurra tudo o que esta por baixo.
    var nota = '';
    var fotos = segue ? atual.fotos : null;
    nota = notaDaFoto(fotos);

    var comImagem = modo !== '3d' && modo !== 'ficha';

    var html =
      '<div class="pdp2-prova__topo">' +
        '<p class="pdp2-prova__t">' + esc(D.titulo) + '</p>' +
        '<button type="button" class="pdp2-prova__x" data-pdp2-prova-fechar>' + esc(tr('concluir')) + '</button>' +
      '</div>' +

      (modos.length > 1
        ? '<div class="pdp2-prova__modos" role="tablist" aria-label="' + esc(tr('o_que_ver')) + '">' + modos.map(function (m) {
            return '<button type="button" class="pdp2-prova__modo' + (m.id === modo ? ' e-agora' : '') +
              '" role="tab" aria-selected="' + (m.id === modo) + '" data-pdp2-prova-modo="' + m.id + '">' + esc(m.nome) + '</button>';
          }).join('') + '</div>'
        // A linha fica mesmo vazia: a grelha da prova conta cinco filhos, e um
        // `hidden` tirava-a da conta — o palco caia na linha automatica, ficava
        // do tamanho da imagem, e a barra das amostras saia do ecra (sofas).
        : '<div class="pdp2-prova__modos pdp2-prova__modos--vazio" aria-hidden="true"></div>') +

      // As outras vistas do mesmo modo, a vista. Uma so em destaque escondia
      // que existem seis.
      (comImagem && n > 1
        ? '<div class="pdp2-prova__vistas" role="tablist" aria-label="' + esc(tr('vistas')) + '">' + urls.map(function (u, i2) {
            return '<button type="button" class="pdp2-prova__v' + (i2 === idx ? ' e-agora' : '') +
              '" role="tab" aria-selected="' + (i2 === idx) + '" data-pdp2-prova-vista="' + i2 + '"' +
              ' aria-label="' + esc(tr('vista_n', { i: i2 + 1, n: n })) + '">' +
              '<img src="' + esc(emLargura(u, 400)) + '" alt="" loading="lazy"></button>';
          }).join('') + '</div>'
        : '<div class="pdp2-prova__vistas"></div>') +

      '<div class="pdp2-prova__palco' + (modo === 'ficha' ? ' pdp2-prova__palco--ficha' : '') + '" data-pdp2-prova-palco>' +
        (comImagem && url
          ? '<img src="' + esc(emLargura(url, modo === 'ambiente' ? 2000 : 900)) + '" alt="' + esc(temEixos ? emSel(D.titulo, sel) : D.titulo) + '">'
          : '') +
        (comImagem && n > 1
          ? '<button type="button" class="pdp2-prova__seta pdp2-prova__seta--ant" data-pdp2-prova-passar="-1" aria-label="' + esc(tr('vista_anterior')) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
            '<button type="button" class="pdp2-prova__seta pdp2-prova__seta--seg" data-pdp2-prova-passar="1" aria-label="' + esc(tr('vista_seguinte')) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>'
          : '') +
        (comImagem && nota ? '<p class="pdp2-prova__nota">' + esc(nota) + '</p>' : '') +
      '</div>' +

      '<div class="pdp2-prova__barra">' +
        (temEixos
          ? '<p class="pdp2-prova__sel">' + (D.opcoes || []).map(function (o, i2) {
              return '<span><b>' + esc(o.nome) + '</b>' + esc(sel[i2]) + '</span>';
            }).join('') + '</p>'
          : '') +
        // A linha de baixo: as amostras e, a direita, o preco com o botao. O par
        // esteve ao lado do nome do que esta escolhido, em cima — lia-se antes
        // da escolha e ficava longe da mao que acabou de tocar numa amostra.
        '<div class="pdp2-prova__baixo">' +
          // Todas as amostras numa corrente so — o tecido e, a seguir, a madeira.
          // Cada eixo na sua coluna fixa deixava a madeira sozinha num campo
          // enorme e empurrava a linha do preco para o fundo do ecra.
          '<div class="pdp2-prova__fila">' + (D.opcoes || []).map(function (o, i2) {
            var sw = swatches[o.nome] || {};
            var medida = eixoDeMedida(i2);
            return (i2 ? '<i class="pdp2-prova__sep" aria-hidden="true"></i>' : '') +
              o.valores.map(function (val) {
                var pp = petproof.indexOf(val) >= 0;
                var atr = ' data-pdp2-prova-sw data-eixo="' + i2 + '" data-valor="' + esc(val) + '" aria-label="' + esc(o.nome + ': ' + val) + '"';
                // Um eixo de medidas nao tem amostra: eram tres bolinhas brancas
                // iguais e nao se sabia qual era o Ø 34 e qual o Ø 64. Leva o
                // valor escrito, como a pastilha fora da prova.
                if (medida) {
                  return '<button type="button" class="pdp2-prova__am pdp2-prova__am--txt' + (val === sel[i2] ? ' e-agora' : '') + '"' + atr + '>' + esc(val) + '</button>';
                }
                // Sem amostra declarada, a bolinha toma a cor que a pagina ja leu
                // da fotografia da variante (pintarSemAmostra), em vez de branco.
                var cor = '';
                if (!sw[val]) {
                  var fora = [].filter.call(raiz.querySelectorAll('.pdp2-swatch[data-eixo="' + i2 + '"]'), function (b) { return b.dataset.valor === val; })[0];
                  if (fora && fora.style.backgroundColor) cor = ' style="background-color:' + fora.style.backgroundColor + '"';
                }
                return '<button type="button" class="pdp2-prova__am' + (val === sel[i2] ? ' e-agora' : '') + (pp ? ' e-pp' : '') + '"' +
                  atr + ' title="' + esc(val) + '"' +
                  (sw[val] ? ' style="background-image:url(' + esc(emLargura(sw[val], 160)) + ')"' : cor) + '></button>';
              }).join('');
          }).join('') + '</div>' +
          // Quem acabou de escolher aqui dentro tinha de fechar a prova e
          // procurar o botao na pagina. O botao submete o mesmo formulario pelo
          // atributo form= — nao ha segundo carrinho, e a variante e a que a
          // prova acabou de escrever em data-pdp2-vid.
          '<div class="pdp2-prova__compra">' +
            '<p class="pdp2-prova__preco">' + (v ? v.p : '') + '</p>' +
            '<button type="submit" class="pdp2-btn pdp2-prova__add" name="add" form="pdp2-form">' + esc(tr('adicionar')) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    // Repintar tudo a cada toque fazia piscar: as miniaturas, a fotografia e as
    // amostras voltavam a nascer e a carregar. Com a mesma estrutura (mesmo
    // modo, mesmas amostras) so se muda o que mudou; a fotografia nova so
    // entra quando ja estiver carregada.
    if (remendarProva(html)) return;
    prova.innerHTML = html;
    var palco = prova.querySelector('[data-pdp2-prova-palco]');
    if (modo === '3d') palco3d(palco);
    if (modo === 'ficha') palco.appendChild(palcoFicha());
    var im = palco.querySelector('img');
    // A cena de ambiente enche o palco; os packshots trazem-se ao centro.
    if (im && modo !== 'ambiente') encherQuadro(im);
    if (im && modo === 'ambiente') im.classList.add('pdp2-prova__img--cena');
  }

  var modoPintado = null;
  function remendarProva(html) {
    var novo = document.createElement('div');
    novo.innerHTML = html;
    var velho = prova;
    var assinatura = function (raizEl) {
      return [
        [].map.call(raizEl.querySelectorAll('[data-pdp2-prova-modo]'), function (b) { return b.dataset.pdp2ProvaModo; }).join(','),
        [].map.call(raizEl.querySelectorAll('[data-pdp2-prova-sw]'), function (b) { return b.dataset.eixo + ':' + b.dataset.valor; }).join(','),
        !!raizEl.querySelector('[data-pdp2-prova-passar]')
      ].join('|');
    };
    var mesmo = modoPintado === modo && velho.firstElementChild && assinatura(velho) === assinatura(novo);
    modoPintado = modo;
    if (!mesmo) return false;

    // chips
    velho.querySelectorAll('[data-pdp2-prova-modo]').forEach(function (b) {
      var ag = b.dataset.pdp2ProvaModo === modo;
      b.classList.toggle('e-agora', ag);
      b.setAttribute('aria-selected', ag);
    });
    // miniaturas: se sao as mesmas, so se move o destaque
    var vV = velho.querySelector('.pdp2-prova__vistas'), vN = novo.querySelector('.pdp2-prova__vistas');
    var srcs = function (el) { return el ? [].map.call(el.querySelectorAll('img'), function (i) { return i.getAttribute('src'); }).join('|') : ''; };
    if (vV && vN) {
      if (srcs(vV) === srcs(vN)) {
        var nb = vN.querySelectorAll('.pdp2-prova__v');
        vV.querySelectorAll('.pdp2-prova__v').forEach(function (b, k) {
          var ag = nb[k] && nb[k].classList.contains('e-agora');
          b.classList.toggle('e-agora', !!ag);
          b.setAttribute('aria-selected', !!ag);
        });
      } else {
        vV.innerHTML = vN.innerHTML;
      }
    }
    // palco
    var pV = velho.querySelector('[data-pdp2-prova-palco]'), pN = novo.querySelector('[data-pdp2-prova-palco]');
    if (modo === '3d') {
      palco3d(pV);
    } else if (modo !== 'ficha' && pV && pN) {
      var imV = pV.querySelector(':scope > img'), imN = pN.querySelector(':scope > img');
      if (imV && imN && imV.getAttribute('src') !== imN.getAttribute('src')) {
        var carregar = new Image();
        var destino = imN.getAttribute('src');
        imV.dataset.pedido = destino;
        carregar.onload = carregar.onerror = function () {
          if (imV.dataset.pedido !== destino) return;   // entretanto pediu-se outra
          imV.setAttribute('src', destino);
          imV.setAttribute('alt', imN.getAttribute('alt') || '');
          if (modo !== 'ambiente') encherQuadro(imV);
        };
        carregar.src = destino;
      }
      var nV = pV.querySelector('.pdp2-prova__nota'), nN = pN.querySelector('.pdp2-prova__nota');
      if (nN && nV) nV.textContent = nN.textContent;
      else if (nN) pV.appendChild(nN);
      else if (nV) nV.remove();
    }
    // o que esta escolhido, as amostras e o preco
    var sV = velho.querySelector('.pdp2-prova__sel'), sN = novo.querySelector('.pdp2-prova__sel');
    if (sV && sN) sV.innerHTML = sN.innerHTML;
    var amN = novo.querySelectorAll('[data-pdp2-prova-sw]');
    velho.querySelectorAll('[data-pdp2-prova-sw]').forEach(function (b, k) {
      b.classList.toggle('e-agora', !!(amN[k] && amN[k].classList.contains('e-agora')));
    });
    var prV = velho.querySelector('.pdp2-prova__preco'), prN = novo.querySelector('.pdp2-prova__preco');
    if (prV && prN) prV.textContent = prN.textContent;
    return true;
  }

  // `contain` centra a IMAGEM, nao a peca. Como os renders sao quadrados com a
  // peca na parte de baixo, ficava meio ecra vazio por cima. Aqui usa-se a
  // medicao que ja se fazia — onde a peca esta e quanto ocupa — para a trazer
  // ao centro e amplia-la ate encher o quadro, sem nunca a cortar.
  function encherQuadro(img) {
    // Os renders das pecas da nossa marcenaria mostram-se como vem: ampliados
    // ate 2,6 vezes para encher o quadro, pixelizavam. Ficam inteiros, em
    // `contain`, e o quadro mostra o estudio a volta.
    if (D.nosso) { img.style.transform = ''; return; }
    var caixa = img.parentNode;
    medir(img.getAttribute('src')).then(function (m) {
      var r = caixa.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var A = m.A || 1;
      var iw = r.width, ih = r.width / A;          // tamanho com `contain`
      if (ih > r.height) { ih = r.height; iw = r.height * A; }
      var pw = (m.fw || 1) * iw, ph = (m.fh || 1) * ih;
      var k = Math.min(r.height * 0.86 / ph, r.width * 0.92 / pw);
      k = Math.max(1, Math.min(k, 2.6));
      var dx = -k * ((m.cx - 0.5) * iw);
      var dy = -k * ((m.cy - 0.5) * ih);
      img.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + k.toFixed(3) + ')';
    });
  }

  // Ao rodar o telemovel ou estreitar a janela, o formato dos ambientes muda.
  if (window.matchMedia) {
    var mqProva = window.matchMedia('(max-width: 759px)');
    var aoMudar = function () { if (modo === 'ambiente') { provaIdx = 0; pintarProva(); } };
    if (mqProva.addEventListener) mqProva.addEventListener('change', aoMudar);
    else if (mqProva.addListener) mqProva.addListener(aoMudar);
  }

  function abrirProva(modoInicial) {
    if (!prova || (!temEixos && !D.candeeiro)) return;
    if (modoInicial) modo = modoInicial;
    // A prova vive dentro de "A escolha", que numa peca sem escolhas (PEROLA)
    // esta escondida — e um position:fixed dentro de um pai escondido nao se
    // ve. Passa a morar na raiz da ficha.
    if (prova.parentNode !== raiz) raiz.appendChild(prova);
    prova.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    pintarProva();
    var f = prova.querySelector('[data-pdp2-prova-fechar]'); if (f) f.focus();
  }

  function fecharProva() {
    if (!prova || prova.hidden) return;
    prova.hidden = true;
    prova.innerHTML = '';
    modoPintado = null;
    document.documentElement.style.overflow = '';
  }

  if (prova) prova.addEventListener('click', function (e) {
    if (e.target.closest('[data-pdp2-prova-fechar]')) { fecharProva(); return; }
    var mo = e.target.closest('[data-pdp2-prova-modo]');
    if (mo) { modo = mo.dataset.pdp2ProvaModo; provaIdx = 0; pintarProva(); return; }
    // Na vista das fotografias da escolha, passar tambem muda a pagina por
    // tras; nas outras vistas o contador e so da prova.
    var segue = modo === 'fotos' || modo === 'fornecedor';
    var pa = e.target.closest('[data-pdp2-prova-passar]');
    if (pa) {
      if (segue) passarNaProva(+pa.dataset.pdp2ProvaPassar);
      else { provaIdx += +pa.dataset.pdp2ProvaPassar; pintarProva(); }
      return;
    }
    var vi = e.target.closest('[data-pdp2-prova-vista]');
    if (vi) {
      if (segue) { foto = +vi.dataset.pdp2ProvaVista; mostrarFoto(false); } else provaIdx = +vi.dataset.pdp2ProvaVista;
      pintarProva(); return;
    }
    var sw = e.target.closest('[data-pdp2-prova-sw]');
    if (!sw) return;
    var i = +sw.dataset.eixo, tentativa = sel.slice();
    tentativa[i] = sw.dataset.valor;
    if (!variante(tentativa)) return;
    sel = tentativa;
    eixoMudado = i;
    eixoProva = i;
    // escolher leva sempre a primeira vista dessa combinacao
    foto = 0; provaIdx = 0;
    pintar();
    pintarProva();
  });

  /* As setas do configurador percorrem todos os renders que existem, de
     combinacao em combinacao: acabadas as vistas de uma, passa-se a primeira
     da seguinte, e a escolha (amostras, preco, carrinho) muda com ela. So as
     combinacoes fotografadas entram na volta; as outras escolhem-se nas
     amostras. A ordem e a das amostras: tecido a tecido, madeira a madeira. */
  function combinacoesFotografadas() {
    var itens = (D.combos && D.combos.items) || [];
    var grupos = [], porChave = {};
    itens.forEach(function (it) {
      var k = JSON.stringify(it.sel || {});
      if (!porChave[k]) {
        var s2 = sel.map(function () { return null; });
        Object.keys(it.sel || {}).forEach(function (e) { var j = eixoDe(e); if (j >= 0) s2[j] = it.sel[e]; });
        porChave[k] = { sel: s2, urls: [] };
        grupos.push(porChave[k]);
      }
      porChave[k].urls.push(it.url);
    });
    var ordem = function (g) {
      return g.sel.map(function (v, j) {
        var i2 = v == null ? 0 : (D.opcoes[j] ? D.opcoes[j].valores.indexOf(v) : 0);
        return ('000' + Math.max(0, i2)).slice(-3);
      }).join('.');
    };
    return grupos.filter(function (g) { return !!variante(g.sel.map(function (v, j) { return v == null ? sel[j] : v; })); })
      .sort(function (a, b) { return ordem(a) < ordem(b) ? -1 : ordem(a) > ordem(b) ? 1 : 0; });
  }

  function passarNaProva(d) {
    var grupos = combinacoesFotografadas();
    if (!grupos.length) { foto += d; mostrarFoto(false); pintarProva(); return; }
    // onde estamos: a combinacao que a fotografia mostra (pode nao ser a
    // escolhida, se essa nao tiver fotografia)
    var mostra = imagens(eixoProva);
    var alvoSel = mostra.sel || sel;
    var g = grupos.findIndex(function (gr) {
      return gr.sel.every(function (v, j) { return v == null || v === alvoSel[j]; });
    });
    if (g < 0) g = 0;
    var n = grupos[g].urls.length;
    var i2 = ((foto % n) + n) % n + d;
    if (i2 >= 0 && i2 < n) { foto = i2; mostrarFoto(false); pintarProva(); return; }
    g = (g + (d > 0 ? 1 : -1) + grupos.length) % grupos.length;
    sel = grupos[g].sel.map(function (v, j) { return v == null ? sel[j] : v; });
    eixoProva = -1; eixoMudado = -1;
    pintar();
    foto = d > 0 ? 0 : grupos[g].urls.length - 1;
    mostrarFoto(false);
    pintarProva();
  }

  function abrirVisor(eixo) {
    carregarAmostras();
    visorEixo = eixo;
    visorIdx = Math.max(0, D.opcoes[eixo].valores.indexOf(sel[eixo]));
    visor.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    pintarVisor();
    var f = visor.querySelector('[data-pdp2-fechar]'); if (f) f.focus();
  }
  function fecharVisor() {
    if (!visor || visor.hidden) return;
    visor.hidden = true;
    visor.innerHTML = '';
    document.documentElement.style.overflow = '';
  }

  raiz.addEventListener('click', function (e) {
    if (e.target.closest('[data-pdp2-abrir-prova]')) { abrirProva((D.modelos || []).length ? '3d' : null); return; }
    var v = e.target.closest('[data-pdp2-ver]');
    if (v) { abrirVisor(+v.dataset.pdp2Ver); return; }
    if (!visor || visor.hidden) return;
    if (e.target.closest('[data-pdp2-fechar]')) { fecharVisor(); return; }
    if (e.target.closest('[data-pdp2-vant]')) { visorIdx--; pintarVisor(); return; }
    if (e.target.closest('[data-pdp2-vseg]')) { visorIdx++; pintarVisor(); return; }
    var am = e.target.closest('[data-pdp2-am]');
    if (am) { visorIdx = +am.dataset.pdp2Am; pintarVisor(); return; }
    if (e.target.closest('[data-pdp2-escolher]')) {
      var tent = sel.slice();
      tent[visorEixo] = D.opcoes[visorEixo].valores[visorIdx];
      if (variante(tent)) { sel = tent; pintar(); }
      fecharVisor();
      var alvo = raiz.querySelector('#escolher');
      if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fecharProva();
    if (prova && !prova.hidden && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
      var d = e.key === 'ArrowRight' ? 1 : -1;
      if (modo === 'fotos' || modo === 'fornecedor') passarNaProva(d);
      else if (modo === 'ambiente') { provaIdx += d; pintarProva(); }
      e.preventDefault();
      return;
    }
    if (!visor || visor.hidden) return;
    if (e.key === 'Escape') fecharVisor();
    if (e.key === 'ArrowLeft') { visorIdx--; pintarVisor(); }
    if (e.key === 'ArrowRight') { visorIdx++; pintarVisor(); }
  });

  /* ---- o topo livre ---------------------------------------------------- */

  // O cabecalho do tema e sticky no computador (74px quando esta preso) e nao
  // existe no telemovel. O espelho encostava a zero e passava-lhe por cima: via-se
  // o logotipo cortado por baixo da fotografia. A altura nao se adivinha nem se
  // escreve a mao — mede-se onde ela esta, e volta a medir-se quando muda.
  var topoAnterior = -1, aMedir = false;

  function medirTopo() {
    var pilha = document.elementsFromPoint(Math.round(window.innerWidth / 2), 2) || [];
    var baixo = 0;
    for (var i = 0; i < pilha.length; i++) {
      var el = pilha[i];
      if (!el || (el.closest && el.closest('[data-pdp2]'))) continue;
      var pos = getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      // so conta o que esta mesmo encostado ao topo e nao e uma cortina inteira
      if (r.top <= 2 && r.bottom > baixo && r.bottom < window.innerHeight * 0.35) baixo = r.bottom;
    }
    baixo = Math.round(baixo);
    if (baixo !== topoAnterior) {
      topoAnterior = baixo;
      raiz.style.setProperty('--pdp2-topo', baixo + 'px');
    }
  }

  function pedirMedida() {
    if (aMedir) return;
    aMedir = true;
    requestAnimationFrame(function () { aMedir = false; medirTopo(); });
  }

  window.addEventListener('scroll', pedirMedida, { passive: true });
  window.addEventListener('resize', pedirMedida);
  medirTopo();

  /* ---- arranque -------------------------------------------------------- */

  // Sem escolha nenhuma, a seccao da escolha nao tem razao de existir.
  if (!temEixos) {
    var sEsc = raiz.querySelector('#escolher');
    if (sEsc) sEsc.hidden = true;
  }


  var d = lerMedidas(D.medidas);
  // Com os desenhos da peça, as três medidas gerais vêm deles (custom.cad_desenhos
  // .medidas, em mm, já arredondadas para apresentação) e não do texto: o texto
  // traduzido nem sempre traz as letras A/L/P que o leitor procura («Al. 850 ×
  // An. 3400») e, em inglês ou espanhol, a secção ficava sem números ou com os
  // números de outra versão. Os números são os mesmos em todas as línguas.
  // O esquema (sem desenhos, ou na medida que não tem modelo) também tem os
  // seus números fora do texto traduzido: cad_desenhos.esquema. Em espanhol o
  // texto «Al. 850 × An. 1270» não se lia e a secção das medidas desaparecia.
  if (D.cad && D.cad.esquema) {
    ['L', 'P', 'A'].forEach(function (k) {
      var v = +D.cad.esquema[k];
      if (v > 0) d[k] = v;
    });
  }
  if (D.cad && D.cad.medidas && !D.cad.so) {
    ['L', 'P', 'A'].forEach(function (k) {
      var v = +D.cad.medidas[k];
      if (v > 0) d[k] = v;
    });
  }
  // Largura util de um elemento: o `clientWidth` INCLUI o padding, e medir o pai
  // com ele dava mais largura do que a que ha de facto. O desenho saia maior do
  // que o papel, o `max-width` encolhia-o depois, e com ele encolhia o tipo —
  // 10,5px onde tinham de ser 11,5. Desconta-se o padding.
  function larguraUtil(el) {
    if (!el) return 0;
    var cs = window.getComputedStyle(el);
    return el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
  }

  var secMed = raiz.querySelector('[data-pdp2-medidas]');
  if (secMed) {
    var svg = desenharTecnico(d, D.medidas);
    var chaves = ['L', 'P', 'A', 'C', 'Ø', 'E'].filter(function (k) { return d[k]; });

    // A secção inteira estava presa ao desenho: `if (svg)`. Mas o desenho
    // precisa de altura, largura E profundidade, e um candeeiro não tem
    // profundidade — o motor devolvia null e a secção ficava escondida. Nos 47
    // candeeiros, que passaram a usar esta ficha, isso queria dizer que a
    // altura e o diâmetro não apareciam em lado nenhum da página. A ficha
    // antiga nunca teve este problema porque nunca amarrou a lista ao desenho.
    // Aqui a lista deixa de depender dele: mostra-se sempre que houver uma
    // medida para mostrar, e o desenho entra quando existir.
    if (chaves.length) {
      secMed.hidden = false;

      var tabela = secMed.querySelector('[data-pdp2-lista]');
      if (tabela) {
        tabela.innerHTML = chaves.map(function (k) {
          return '<div><dt>' + ROTULOS[k] + '</dt><dd>' + mm(d[k]) + '<span>mm</span></dd></div>';
        }).join('');
      }

      var t = secMed.querySelector('[data-pdp2-med-titulo]');
      if (t) {
        t.textContent = d.L >= 1500
          ? tr('med_largo', { m: (d.L / 1000).toFixed(2).replace('.', tr('decimal') || '.') })
          : tr('med_curto');
      }

      // A frase de entrada fala da porta que está desenhada ao lado da peça. A
      // porta só entra no desenho de quem tem profundidade — um móvel que passa
      // por um vão. Um candeeiro não tem, e leva a escala gráfica em vez dela:
      // ali a frase mentia, mesmo havendo desenho.
      var intro = secMed.querySelector('[data-pdp2-med-intro]');
      if (intro) intro.hidden = !(svg && d.A && d.L && d.P);

      // O desenho precisa de saber a que largura vai ser mostrado: o tipo e as
      // folgas são medidos em pixeis do ecrã, e é isso que o faz ler-se igual
      // num telemóvel e num monitor. Antes o tipo era uma fracção da folha e
      // saía a 3,9px no telemóvel — daí a secção ter andado escondida abaixo
      // dos 900px. Como a medida vem do ecrã, redesenha-se quando ele muda.
      var folha = secMed.querySelector('[data-pdp2-cotas]');
      var nota = secMed.querySelector('[data-pdp2-med-nota]');
      // O esquema gerado: o que a maior parte das peças mostra enquanto não
      // tiver os seus desenhos. Traço leve e sem papel à volta (ver `leve` no
      // pistacho-cotas.js).
      var esquema = function () {
        if (!(svg && folha)) return;
        // Mede-se o PAI, não a folha: a folha encolhe para o desenho, e uma
        // folha vazia tem largura zero — media-se zero e não se desenhava nada.
        // Do lado largo a folha fica-se por pouco mais de metade, para os
        // números caberem ao lado; do lado estreito toma a linha toda e os
        // números passam para baixo.
        var feitoA = 0;
        var desenhar = function () {
          folha.hidden = false;
          var disp = Math.round(larguraUtil(folha.parentNode));
          if (disp < 120) return;
          var alvo = disp >= 620 ? Math.min(Math.round(disp * 0.58), 620) : disp;
          var w = alvo - 36;                            // 18px de papel de cada lado
          if (w < 150 || Math.abs(w - feitoA) < 8) return;
          feitoA = w;
          var novo = desenharTecnico(d, D.medidas, { larguraPx: w, leve: true });
          if (!novo) return;
          folha.innerHTML = novo;
          var med = /width:(\d+)px/.exec(novo);
          folha.style.width = (med ? (+med[1] + 36) : alvo) + 'px';
        };
        desenhar();
        if (nota) {
          nota.textContent = tr('med_nota') + ' ' + (d.P ? tr('med_porta') : tr('med_regua'));
          nota.hidden = false;
        }
        var aEsperar;
        window.addEventListener('resize', function () {
          clearTimeout(aEsperar);
          aEsperar = setTimeout(desenhar, 180);
        });
      };

      if (!montarCad(secMed, d, esquema)) esquema();
    }
  }

  /* ---- os desenhos da própria peça --------------------------------------

     Com `custom.cad_desenhos` (JSON: vistas frente/corte/planta com o URL do
     SVG em linha, níveis, fundo útil e marcas; `porta` com as peças) a secção
     mostra os desenhos da peça em vez do esquema. O traço vem de fora e é
     reescrito no motor (MOTOR.cadLer / cadVista); aqui decide-se só a escala e
     a arrumação.

     A escala: no computador as três vistas partilham os mesmos milímetros por
     pixel — de frente e de lado assentam no mesmo chão, a de cima fica por
     baixo da de frente — e o conjunto enche a largura da secção. No telemóvel
     cada uma ocupa a coluna: de frente e de cima partilham a escala; a de lado
     tem a sua, senão as alturas ficavam coladas umas às outras.

     Devolve false quando não há desenhos, e a secção fica com o esquema. Se um
     SVG falhar, a faixa esconde-se e volta o esquema: nunca fica pior. */
  function montarCad(sec, d, recurso) {
    var C = D.cad;
    var el = sec.querySelector('[data-pdp2-cad]');
    if (!el || !C || !C.vistas || !MOTOR.cadVista || !window.fetch || !window.DOMParser) return false;
    function specDe(vistas) {
      var s = {};
      (vistas || []).forEach(function (v) { if (v && v.url && /^https:\/\//.test(v.url)) s[v.vista] = v; });
      return s;
    }
    // Os números que se escrevem: os dos desenhos (cad_desenhos.medidas, já
    // postos em `d`) ou, sem eles, a cabeça de custom.medidas.
    var bm = C.medidas || {};
    var base = { spec: specDe(C.vistas), nums: { L: +bm.L || d.L, P: +bm.P || d.P, A: +bm.A || d.A },
      so: C.so ? String(C.so).toLowerCase() : '' };
    if (!base.spec.frente || !base.nums.L || !base.nums.A) return false;
    /* As medidas que mudam com uma opção: a cama King é 200 mm mais larga do
       que a Queen, e tem desenhos seus. `cad_desenhos.alt` traz, por cada uma,
       o texto que a opção contém (`se`), as vistas e as medidas. A escolha
       da página troca o conjunto; sem `alt`, fica o de sempre. */
    var alts = (C.alt || []).map(function (a) {
      var m = a.medidas || {};
      return { se: String(a.se || '').toLowerCase(), spec: specDe(a.vistas),
        nums: { L: +m.L || base.nums.L, P: +m.P || base.nums.P, A: +m.A || base.nums.A } };
    }).filter(function (a) { return a.se && a.spec.frente; });
    /* `cad_desenhos.so`: os desenhos só valem para a opção que o contém (as
       mesas BELLE, RIVIERA e IMPERIUM só têm modelo na medida maior). Nas
       outras medidas volta o esquema feito a partir de custom.medidas: um
       desenho de 2,20 m não pode passar por uma mesa de 1,80 m. */
    function conjuntoDe(vid) {
      var v = null;
      if (vid) D.variantes.forEach(function (x) { if (String(x.id) === String(vid)) v = x; });
      var ops = v ? (v.o || []).join(' | ').toLowerCase() : '';
      for (var i = 0; i < alts.length; i++) if (ops && ops.indexOf(alts[i].se) >= 0) return alts[i];
      if (base.so && ops.indexOf(base.so) < 0) return null;
      return base;
    }
    var elVidCad = raiz.querySelector('[data-pdp2-vid]');
    var atual = conjuntoDe((raiz._pdp2Escolha && raiz._pdp2Escolha.variante) || (elVidCad && elVidCad.value));

    var geos = {};
    var introCad = sec.querySelector('[data-pdp2-cad-intro]');
    // A frase de entrada fala do que importa em cada família: as alturas de se
    // sentar num sofá, a cabeceira numa cama, o tampo numa mesa.
    if (introCad && C.tipo && tr('cad_intro_' + C.tipo)) {
      var pIntro = introCad.querySelector('p');
      if (pIntro) pIntro.textContent = tr('cad_intro_' + C.tipo);
    }
    var introEsq = sec.querySelector('[data-pdp2-med-intro]');
    var med = sec.querySelector('.pdp2-med');
    var titulo = sec.querySelector('[data-pdp2-med-titulo]');

    // Os números no canto: as três gerais, as alturas (de sentar, do tampo, da
    // cabeceira), o fundo útil e as marcas (o tabuleiro).
    var lista = el.querySelector('[data-pdp2-cad-lista]');
    var DT = { assento: 'cad_dt_assento', braco: 'cad_dt_braco', pes: 'cad_dt_pes', tampo: 'cad_dt_tampo',
      sob_tampo: 'cad_dt_sob_tampo', cabeceira: 'cad_dt_cabeceira', base: 'cad_dt_base' };
    function pintarNumeros() {
      if (!atual) return;
      var spec = atual.spec, nums = atual.nums;
      var linhas = ['L', 'P', 'A'].filter(function (k) { return nums[k]; }).map(function (k) {
        return [ROTULOS[k], mm(nums[k])];
      });
      if (spec.corte) {
        (spec.corte.niveis || []).slice().sort(function (a, b) { return b.z - a.z; }).forEach(function (n) {
          if (DT[n.k]) linhas.push([tr(DT[n.k]), mm(n.z)]);
        });
        if (spec.corte.livre && spec.corte.livre.v) linhas.push([tr('cad_dt_livre'), '≈ ' + mm(spec.corte.livre.v)]);
      }
      if (spec.planta) {
        (spec.planta.marcas || []).forEach(function (m) { if (m.t) linhas.push([tr('marca_' + m.k), m.t]); });
      }
      if (lista) {
        lista.innerHTML = linhas.map(function (l) {
          return '<div><dt>' + esc(l[0]) + '</dt><dd>' + esc(l[1]) + '<span>mm</span></dd></div>';
        }).join('');
      }
      if (titulo && nums.L) {
        titulo.textContent = nums.L >= 1500
          ? tr('med_largo', { m: (nums.L / 1000).toFixed(2).replace('.', tr('decimal') || '.') })
          : tr('med_curto');
      }
      ['frente', 'planta', 'corte'].forEach(function (k) {
        var f = el.querySelector('[data-vista="' + k + '"]');
        if (f) f.hidden = !spec[k];
      });
    }
    pintarNumeros();
    var porta = el.querySelector('[data-pdp2-cad-porta]');
    if (porta && C.porta && C.porta.peca) {
      porta.querySelector('[data-pdp2-cad-porta-p]').textContent =
        tr('cad_porta_p', { n: C.porta.n || '', peca: C.porta.peca, base: C.porta.base || '' });
      porta.hidden = false;
    }

    var feitoW = 0;
    function desenhar() {
      if (!atual) return;
      var spec = atual.spec, nums = atual.nums;
      var ordem = ['frente', 'planta', 'corte'].filter(function (k) { return spec[k]; });
      var g = {};
      for (var i = 0; i < ordem.length; i++) { g[ordem[i]] = geos[spec[ordem[i]].url]; if (!g[ordem[i]]) return; }
      var cw = Math.floor(larguraUtil(el));
      if (cw < 200 || Math.abs(cw - feitoW) < 6) return;
      feitoW = cw;
      var F = {};
      ordem.forEach(function (k) { F[k] = MOTOR.cadFolgas(k, spec[k]); });
      var largo = cw >= 860 && spec.corte;
      var gap = 56;
      var K = {};
      if (largo) {
        var fixo = F.frente.l + F.frente.r + gap + F.corte.l + F.corte.r;
        var k = (g.frente.W + g.corte.W) / Math.max(200, cw - fixo);
        k = Math.max(k, g.frente.W / 900);          // um sofá de 3,4 m não passa dos 900px
        ordem.forEach(function (v) { K[v] = k; });
        el.style.setProperty('--pdp2-cad-col', Math.round(F.frente.l + g.frente.W / k + F.frente.r) + 'px');
      } else {
        var kf = g.frente.W / Math.max(120, cw - F.frente.l - F.frente.r);
        K.frente = kf; K.planta = kf;
        if (spec.corte) K.corte = Math.max(g.corte.W / Math.max(120, cw - F.corte.l - F.corte.r), g.corte.W / 300);
        el.style.removeProperty('--pdp2-cad-col');
      }
      el.classList.toggle('pdp2-cad--largo', !!largo);
      ordem.forEach(function (v) {
        var r = MOTOR.cadVista(v, spec[v], g[v], K[v], nums, F[v]);
        var fig = el.querySelector('[data-vista="' + v + '"] .pdp2-cad__d');
        if (fig) fig.innerHTML = r.svg;
      });
    }
    function carregar(conj) {
      return Promise.all(Object.keys(conj.spec).map(function (k) {
        var u = conj.spec[k].url;
        return MOTOR.cadLer(u).then(function (g) { geos[u] = g; });
      }));
    }

    /* A medida sem modelo e sem números seus (IPANEMA oval de 180 cm: o
       `esquema` do cad_desenhos repete os da de 220). Mostrar esses números
       naquela medida era dizer ao cliente que uma mesa de 1,80 m mede 2,20 m.
       Aí a secção não mostra números nem desenhos: diz só que estão em
       confirmação. BELLE, RIVIERA e IMPERIUM têm no `esquema` os números da
       medida menor e continuam a mostrá-los. */
    var confirmar = sec.querySelector('[data-pdp2-med-confirmar]');
    var nota = sec.querySelector('[data-pdp2-med-nota]');
    var esq = C.esquema || {};
    var semNumeros = !!base.so && (!(+esq.L) || (+esq.L === base.nums.L && +esq.P === base.nums.P));
    function mostrarConfirmar() {
      el.hidden = true;
      if (introCad) introCad.hidden = true;
      if (med) med.hidden = true;
      if (introEsq) introEsq.hidden = true;
      if (nota) nota.hidden = true;
      if (titulo) titulo.hidden = true;
      if (confirmar) confirmar.hidden = false;
    }
    function semModelo() {
      if (semNumeros) mostrarConfirmar(); else mostrarEsquema();
    }

    var esquemaFeito = false;
    function mostrarEsquema() {
      el.hidden = true;
      if (introCad) introCad.hidden = true;
      if (confirmar) confirmar.hidden = true;
      if (titulo) titulo.hidden = false;
      if (nota && esquemaFeito) nota.hidden = false;
      if (med) med.hidden = false;
      if (introEsq) introEsq.hidden = false;
      if (titulo && d.L) {
        titulo.textContent = d.L >= 1500
          ? tr('med_largo', { m: (d.L / 1000).toFixed(2).replace('.', tr('decimal') || '.') })
          : tr('med_curto');
      }
      if (!esquemaFeito) { esquemaFeito = true; recurso(); }
    }
    function mostrarDesenhos() {
      if (confirmar) confirmar.hidden = true;
      if (titulo) titulo.hidden = false;
      if (nota) nota.hidden = true;
      if (med) med.hidden = true;
      if (introEsq) introEsq.hidden = true;
      el.hidden = false;
      if (introCad) introCad.hidden = false;
    }
    function falhar() { atual = null; mostrarEsquema(); }

    // O esquema não aparece por baixo enquanto os desenhos carregam.
    if (atual) {
      if (med) med.hidden = true;
      if (introEsq) introEsq.hidden = true;
    } else {
      semModelo();
    }

    var pedido = false;
    function pedir() {
      if (pedido || !atual) return;
      pedido = true;
      carregar(atual).then(function () {
        mostrarDesenhos();
        desenhar();
        var espera;
        window.addEventListener('resize', function () {
          clearTimeout(espera);
          espera = setTimeout(desenhar, 180);
        });
      }).catch(falhar);
    }
    if (alts.length || base.so) {
      raiz.addEventListener('pdp2:escolha', function (e) {
        var novo = conjuntoDe(e.detail && e.detail.variante);
        if (novo === atual) return;
        atual = novo;
        if (!atual) { semModelo(); return; }
        pintarNumeros();
        if (!pedido) { pedir(); return; }
        carregar(atual).then(function () { mostrarDesenhos(); feitoW = 0; desenhar(); }).catch(falhar);
      });
    }
    // O traço pesa umas dezenas de KB: pede-se quando a secção se aproxima.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); pedir(); }
      }, { rootMargin: '900px 0px' });
      io.observe(sec);
    } else {
      pedir();
    }
    return true;
  }

  var precos = D.variantes.map(function (v) { return v.c; });
  var mexe = Math.min.apply(null, precos) !== Math.max.apply(null, precos);
  var elC = raiz.querySelector('[data-pdp2-combs]');
  var elN = raiz.querySelector('[data-pdp2-preco-nota]');
  // Um candeeiro não tem tecido nem madeira, e a frase do "fica mais barato"
  // não é voz para ele. Nos candeeiros: o número de opções e, só quando o preço
  // varia, onde se lê.
  if (D.candeeiro) {
    if (elC) elC.textContent = tr(mexe ? 'opcoes' : 'opcoes_mesmo_preco', { n: D.variantes.length });
    if (elN) {
      if (mexe) elN.innerHTML = '<p>' + esc(tr('preco_varia')) + '</p>';
      else elN.hidden = true;
    }
  } else {
    if (elC) elC.textContent = tr('combinacoes', { n: D.variantes.length }) + (mexe ? '' : ' ' + tr('nenhuma_mais'));
    if (elN) {
      elN.innerHTML = '<p>' + (mexe
        ? esc(tr('preco_muda'))
        : esc(tr('preco_nao_muda'))) + '</p>';
    }
  }

  montarOpcoes();
  pintar();
  arrancou = true;

  // Ampliar as cotas. No telemovel os numeros ficam com cinco pixeis de altura,
  // que e o erro que o Baymard documenta como o mais comum nas imagens de
  // dimensoes: texto pequeno de mais para ler sem fazer zoom. Aqui abre-se.
  (function () {
    var lupa = null;
    function fechar() {
      if (!lupa) return;
      lupa.remove(); lupa = null;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', tecla);
    }
    function tecla(e) { if (e.key === 'Escape') fechar(); }
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp2-zoom]');
      if (!b) return;
      fechar();
      lupa = document.createElement('div');
      // A lupa nasceu para os desenhos cotados: no telemovel abre-os a 2,6 vezes
      // a largura do ecra, para se lerem os numeros. Uma fotografia aberta assim
      // era um recorte gigante — um globo inteiro no ecra, meio abajur em branco.
      // As fotografias abrem inteiras, ajustadas ao ecra.
      var cotas = !!b.closest('.pdp2-cotadas');
      lupa.className = 'pdp2-lupa' + (cotas ? '' : ' pdp2-lupa--foto');
      document.documentElement.style.overflow = 'hidden';
      lupa.innerHTML = '<img src="' + esc(b.dataset.pdp2Zoom) + '" alt="">' +
        '<button type="button" class="pdp2-lupa__x" aria-label="' + esc(tr('fechar')) + '">' + esc(tr('fechar')) + '</button>';
      lupa.addEventListener('click', fechar);
      document.body.appendChild(lupa);
      document.addEventListener('keydown', tecla);
      lupa.querySelector('.pdp2-lupa__x').focus();
    });
  })();

  // A barra so faz falta depois de o bloco de compra sair do ecra. Antes disso
  // repetia o preco que esta a dois centimetros dali e comia o fundo da pagina.
  var barra = raiz.querySelector('.pdp2-barra');
  var abre = raiz.querySelector('.pdp2-abre__lado');
  if (barra && abre && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) barra.removeAttribute('data-visivel');
        else barra.setAttribute('data-visivel', '');
      });
    }, { rootMargin: '-40px 0px 0px 0px' }).observe(abre);
  } else if (barra) {
    barra.setAttribute('data-visivel', '');
  }

  /* ---- a combinação que não se vende ----------------------------------

     As pedras (Dekton, Awake, Taga) aparecem para se verem, mas são a única
     combinação que não se compra (política DENY na loja: «Indisponível»). Sem
     isto o botão ficava activo e o Shopify respondia com uma página de erro.
     Com a variante esgotada o botão diz «Indisponível» e não carrega; o
     WhatsApp continua ao lado para quem a quiser por consulta. */
  function disponivel(vid) {
    var v = null;
    D.variantes.forEach(function (x) { if (String(x.id) === String(vid)) v = x; });
    var ok = !v || v.ok !== false;
    document.querySelectorAll('#pdp2-form button[type="submit"], button[form="pdp2-form"]').forEach(function (b) {
      if (b.dataset.pdp2Txt === undefined) b.dataset.pdp2Txt = b.textContent;
      b.disabled = !ok;
      b.textContent = ok ? b.dataset.pdp2Txt : (tr('indisponivel') || b.dataset.pdp2Txt);
      b.classList.toggle('pdp2-btn--off', !ok);
    });
  }
  if (raiz && D.variantes.some(function (x) { return x.ok === false; })) {
    var vidDisp = raiz.querySelector('[data-pdp2-vid]');
    raiz.addEventListener('pdp2:escolha', function (e) {
      var vid = e.detail && e.detail.variante;
      disponivel(vid);
      setTimeout(function () { disponivel(vid); }, 0);
    });
    if (vidDisp) disponivel(vidDisp.value);
  }
  } // fim de arrancar()

  // Em PT os dados ja estao na lingua das chaves: arranca-se ja, como sempre.
  // Em /en e /es pede-se primeiro a peca em PT. Se a resposta nao chegar em
  // 3 s (ou falhar), arranca-se sem traducao: fica como estava antes disto.
  if (D.fonte_pt && (D.opcoes || []).length && window.fetch) {
    var arrancou0 = false;
    var seguir = function () { if (arrancou0) return; arrancou0 = true; arrancar(); };
    var espera = setTimeout(seguir, 3000);
    fetch(D.fonte_pt, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (pt) { if (!arrancou0) { try { localizar(pt); } catch (e) { PT = null; } } })
      .catch(function () {})
      .then(function () { clearTimeout(espera); seguir(); });
  } else {
    arrancar();
  }
})();

/* O iPhone pinta as faixas de seguranca com a cor do documento, nao com a da
   pagina: em modo escuro ficavam duas barras brancas. Sao tres coisas do
   documento, nao do CSS — a cor do <html>, a `theme-color` que o Safari le, e
   o `viewport-fit`, sem o qual a pagina nem chega a estender-se por baixo
   delas. A do topo continua a depender do que estiver la (barra de anuncio,
   cabecalho transparente); a do fundo passa a acompanhar a pagina. */
(function () {
  'use strict';
  if (!document.querySelector('.pdp2--noite')) return;
  var raiz = document.documentElement;
  raiz.style.background = '#0D0C0B';
  var vp = document.querySelector('meta[name="viewport"]');
  if (vp && vp.content.indexOf('viewport-fit') === -1) vp.content += ', viewport-fit=cover';
  var tc = document.querySelector('meta[name="theme-color"]');
  if (!tc) { tc = document.createElement('meta'); tc.name = 'theme-color'; document.head.appendChild(tc); }
  tc.setAttribute('content', '#0D0C0B');
}());

/* ---- a vista 3D -----------------------------------------------------------
   So existe em pecas com modelo 3D na galeria. Nao ha imagem parada nem botao:
   o modelo pede-se quando a seccao chega a 400 px do ecra, e aparece no palco
   no tom da pagina. O scroll vertical do telemovel continua a ser da pagina
   (touch-action: pan-y no <model-viewer>).

   Para se perceber que a peca roda: uma pastilha "Arraste para rodar" e, na
   primeira vez que o palco fica meio visivel, uma volta lenta de ida e volta
   (nada de rotacao continua). Quem pede movimento reduzido nao tem a volta.
   Ao primeiro toque a pastilha sai e aparece "Repor vista".

   A biblioteca (model-viewer 4.1, asset do tema) entra por um <script
   type="module">, e nao por import(): o Shopify minifica os assets JS e
   transforma import() em require(), que nao existe no browser — falhava em
   menos de um segundo sem um unico pedido de rede. */
(function () {
  var caixa = document.querySelector('[data-pdp2-3d]');
  if (!caixa) return;
  var palco = caixa.querySelector('[data-pdp2-3d-palco]');
  var T3 = {};
  try { T3 = JSON.parse(document.querySelector('[data-pdp2-t]').textContent) || {}; } catch (e) { T3 = {}; }
  var repor = caixa.querySelector('[data-pdp2-3d-repor]');
  var dica = caixa.querySelector('[data-pdp2-3d-dica]');
  var estado = caixa.querySelector('[data-pdp2-3d-estado]');
  var tpl = caixa.querySelector('[data-pdp2-3d-tpl]');
  // As miniaturas por baixo do palco: 3D ou uma fotografia, no mesmo sitio.
  var elVistas = caixa.parentNode.querySelector('[data-pdp2-vistas]');
  var elFoto = palco.querySelector('[data-pdp2-3d-foto]');
  var emFoto = false;
  var ORBITA = '20deg 78deg auto';
  var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vista = null, espera = null, pedido = false, desistiu = false, mexeu = false, voltaDada = false;

  function falhou() {
    clearTimeout(espera);
    desistiu = true;
    if (vista) vista.remove();
    vista = null;
    // Havendo fotografias, o palco fica e passa a mostra-las; o botao 3D sai.
    var fotos = elVistas ? elVistas.querySelectorAll('[data-pdp2-vista]:not([data-pdp2-vista="3d"])') : [];
    if (fotos.length && elFoto) {
      var b3d = elVistas.querySelector('[data-pdp2-vista="3d"]');
      if (b3d) b3d.remove();
      verVista(fotos[0]);
      if (fotos.length < 2) elVistas.hidden = true;
      estado.textContent = T3['3d_falhou'] || '';
      return;
    }
    caixa.classList.add('pdp2-3d--falhou');
    estado.textContent = T3['3d_falhou'] || '';
  }

  function verVista(b) {
    if (!b || !elFoto) return;
    if (elVistas) elVistas.querySelectorAll('[data-pdp2-vista]').forEach(function (x) {
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });
    var alvo = b.getAttribute('data-pdp2-vista');
    emFoto = alvo !== '3d';
    if (emFoto) {
      // a <img> nasce so quando ha fotografia: vazia, era uma imagem partida
      var img = elFoto.querySelector('img');
      if (!img) { img = document.createElement('img'); elFoto.appendChild(img); }
      img.src = alvo;
      img.alt = b.getAttribute('data-alt') || '';
      // a lupa da pagina abre o que estiver neste atributo
      elFoto.setAttribute('data-pdp2-zoom', alvo);
    }
    elFoto.hidden = !emFoto;
    palco.classList.toggle('pdp2-3d__palco--foto', emFoto);
  }
  if (elVistas) elVistas.addEventListener('click', function (e) {
    verVista(e.target.closest('[data-pdp2-vista]'));
  });

  // A escolha mudou (amostras da pagina, da barra ou do configurador): o
  // modelo passa ao da variante, e das fotografias ligadas a variantes ficam
  // so as desta. Se o palco estava numa dessas fotografias, passa a da nova.
  var srcPedido = '';
  var raizPdp = caixa.closest('[data-pdp2]');
  function aplicarEscolha(d) {
    d = d || {};
    if (d.modelo) {
      srcPedido = d.modelo;
      if (vista && vista.getAttribute('src') !== d.modelo) { vista.setAttribute('src', d.modelo); prepararAr(); }
    }
    if (!elVistas || !d.variante) return;
    var atual = elVistas.querySelector('[data-pdp2-vista][aria-pressed="true"]');
    var trocar = null;
    elVistas.querySelectorAll('[data-pdp2-vista-variantes]').forEach(function (b) {
      var minha = (' ' + b.getAttribute('data-pdp2-vista-variantes') + ' ').indexOf(' ' + d.variante + ' ') >= 0;
      b.hidden = !minha;
      if (minha && !trocar) trocar = b;
    });
    if (atual && atual.hidden) verVista(trocar || elVistas.querySelector('[data-pdp2-vista="3d"]'));
  }
  if (raizPdp) {
    raizPdp.addEventListener('pdp2:escolha', function (e) { aplicarEscolha(e.detail); });
    // a primeira pintura aconteceu antes deste bloco correr
    if (raizPdp._pdp2Escolha) aplicarEscolha(raizPdp._pdp2Escolha);
  }

  // Ver na sua casa. O telemovel abre a peca em tamanho real: Android pelo
  // GLB (WebXR ou Scene Viewer), iPhone pelo USDZ que o Shopify gera de cada
  // modelo (Quick Look). O botao so aparece se o aparelho o permitir, e segue
  // a variante escolhida.
  var botaoAr = palco.querySelector('[data-pdp2-3d-ar]');
  var usdzDe = {};
  function nomeGlb(s) { return String(s || '').split('?')[0].split('/').pop(); }
  try {
    var dadosPdp = raizPdp && JSON.parse(raizPdp.querySelector('[data-pdp2-dados]').textContent);
    ((dadosPdp && dadosPdp.modelos) || []).forEach(function (m) { if (m.usdz) usdzDe[nomeGlb(m.src)] = m.usdz; });
  } catch (e) {}
  var arLocal = caixa.getAttribute('data-pdp2-3d-ar-local');
  function prepararAr() {
    // Os de teto (suspensao, plafon, linear) ficam sem AR: nao ha onde os pousar.
    if (!vista || !arLocal) return;
    vista.setAttribute('ar', '');
    vista.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
    vista.setAttribute('ar-scale', 'fixed');
    vista.setAttribute('ar-placement', arLocal);
    var usdz = usdzDe[nomeGlb(vista.getAttribute('src'))];
    if (usdz) vista.setAttribute('ios-src', usdz); else vista.removeAttribute('ios-src');
  }
  function mostrarBotaoAr() {
    if (botaoAr) botaoAr.hidden = !(vista && vista.canActivateAR);
  }
  if (botaoAr) botaoAr.addEventListener('click', function () {
    if (vista && vista.canActivateAR) vista.activateAR();
  });

  // Primeiro gesto da pessoa: a dica ja fez o seu trabalho.
  function tocou() {
    if (mexeu) return;
    mexeu = true;
    dica.classList.add('a-sair');
    setTimeout(function () { dica.hidden = true; }, 650);
    repor.hidden = false;
  }

  // Uma volta de ida e volta, uma vez. O model-viewer amortece a mudanca de
  // orbita sozinho; so se abranda o amortecimento enquanto ela dura.
  function darVolta() {
    if (voltaDada || calmo || mexeu || emFoto || !vista) return;
    voltaDada = true;
    var amortecimento = vista.getAttribute('interpolation-decay');
    vista.setAttribute('interpolation-decay', '260');
    setTimeout(function () { if (!mexeu) vista.cameraOrbit = '52deg 76deg auto'; }, 500);
    setTimeout(function () { if (!mexeu) vista.cameraOrbit = ORBITA; }, 2300);
    setTimeout(function () {
      if (amortecimento === null) vista.removeAttribute('interpolation-decay');
      else vista.setAttribute('interpolation-decay', amortecimento);
    }, 4300);
  }

  function mostrar() {
    if (desistiu || vista) return;
    var modelo = tpl && tpl.content.querySelector('model-viewer');
    if (!modelo) { falhou(); return; }
    vista = modelo.cloneNode(true);
    // a escolha pode ja ter pedido o modelo de outra cor (NOMADA Bege)
    if (srcPedido) vista.setAttribute('src', srcPedido);
    // o model_viewer_tag poe sempre um poster; aqui nao se quer imagem parada
    vista.removeAttribute('poster');
    // E marca o elemento com data-shopify-feature, que faz o Shopify descarregar
    // o seu model-viewer 1.12 por cima do nosso: um download inutil e um erro
    // de registo duplicado na consola.
    vista.removeAttribute('data-shopify-feature');
    // Por omissao o model-viewer so descarrega o GLB quando fica visivel; nos ja
    // decidimos quando (400 px antes), e o prazo de 30 s conta a partir daqui.
    // Sem isto, quem parasse pouco acima da seccao via o palco dado por falhado.
    vista.setAttribute('loading', 'eager');
    prepararAr();
    vista.addEventListener('load', function () {
      clearTimeout(espera);
      mostrarBotaoAr();
      estado.textContent = T3['3d_pronta'] || '';
      if (!mexeu) dica.hidden = false;
      if ('IntersectionObserver' in window) {
        var meio = new IntersectionObserver(function (entradas) {
          if (!entradas[0].isIntersecting) return;
          meio.disconnect();
          darVolta();
        }, { threshold: 0.5 });
        meio.observe(palco);
      }
    });
    vista.addEventListener('camera-change', function (e) {
      if (e.detail && e.detail.source === 'user-interaction') tocou();
    });
    vista.addEventListener('pointerdown', tocou);
    vista.addEventListener('error', falhou);
    palco.appendChild(vista);
  }

  function carregar() {
    if (pedido) return;
    pedido = true;
    // Uma rede lenta nao pode deixar o palco vazio para sempre.
    espera = setTimeout(falhou, 30000);
    if (window.customElements && customElements.get('model-viewer')) { mostrar(); return; }
    var lib = caixa.getAttribute('data-pdp2-3d-lib') || '';
    if (lib.indexOf('//') === 0) lib = location.protocol + lib;
    var s = document.createElement('script');
    s.type = 'module';
    s.src = lib;
    s.onerror = falhou;
    document.head.appendChild(s);
    customElements.whenDefined('model-viewer').then(mostrar);
  }

  if ('IntersectionObserver' in window) {
    var olho = new IntersectionObserver(function (entradas) {
      if (!entradas[0].isIntersecting) return;
      olho.disconnect();
      carregar();
    }, { rootMargin: '400px 0px' });
    olho.observe(caixa);
  } else {
    carregar();
  }

  repor.addEventListener('click', function () {
    if (!vista) return;
    vista.cameraOrbit = ORBITA;
    vista.cameraTarget = 'auto auto auto';
    vista.fieldOfView = '30deg';
    if (typeof vista.jumpCameraToGoal === 'function') vista.jumpCameraToGoal();
  });
})();
